import cuchi1 from './assets/tours/cuchi/cuchi (5).jpg';
import cuchi2 from './assets/tours/cuchi/cuchi (2).jpg';
import cuchi3 from './assets/tours/cuchi/cuchi (3).jpg';
import cuchi4 from './assets/tours/cuchi/cuchi (4).jpg';
import cuchi5 from './assets/tours/cuchi/cuchi (1).jpg';

import mekong1 from './assets/tours/mekong/mekong (1).jpg';
import mekong2 from './assets/tours/mekong/mekong (2).jpg';
import mekong3 from './assets/tours/mekong/mekong (3).jpg';
import mekong4 from './assets/tours/mekong/mekong (4).jpg';
import mekong5 from './assets/tours/mekong/mekong (5).jpg';

import hue1 from './assets/tours/hue/hue (1).jpg';
import hue2 from './assets/tours/hue/hue (2).jpg';
import hue3 from './assets/tours/hue/hue (3).jpg';
import hue4 from './assets/tours/hue/hue (4).jpg';
import hue5 from './assets/tours/hue/hue (5).jpg';

import halong1 from './assets/tours/halong/halong (1).jpg';
import halong2 from './assets/tours/halong/halong (2).jpg';
import halong3 from './assets/tours/halong/halong (3).jpg';
import halong4 from './assets/tours/halong/halong (4).jpg';
import halong5 from './assets/tours/halong/halong (5).jpg';

import bana1 from './assets/tours/bana/bana (1).jpg';
import bana2 from './assets/tours/bana/bana (2).jpg';
import bana3 from './assets/tours/bana/bana (3).jpg';
import bana4 from './assets/tours/bana/bana (4).jpg';
import bana5 from './assets/tours/bana/bana (5).jpg';

import sapa1 from './assets/tours/sapa/sapa (1).jpg';
import sapa2 from './assets/tours/sapa/sapa (2).jpg';
import sapa3 from './assets/tours/sapa/sapa (3).jpg';
import sapa4 from './assets/tours/sapa/sapa (4).jpg';
import sapa5 from './assets/tours/sapa/sapa (5).jpg';

import muine1 from './assets/tours/muine/muine (2).jpg';
import muine2 from './assets/tours/muine/muine (1).jpg';
import muine3 from './assets/tours/muine/muine (3).jpg';
import muine4 from './assets/tours/muine/muine (4).jpg';
import muine5 from './assets/tours/muine/muine (5).jpg';

import cangio1 from './assets/tours/cangio/cangio (2).jpg';
import cangio2 from './assets/tours/cangio/cangio (1).jpg';
import cangio3 from './assets/tours/cangio/cangio (3).jpg';
import cangio4 from './assets/tours/cangio/cangio (4).jpg';
import cangio5 from './assets/tours/cangio/cangio (5).jpg';

import motorbike5 from './assets/tours/motorbike/motorbike (1).jpg';
import motorbike2 from './assets/tours/motorbike/motorbike (2).jpg';
import motorbike3 from './assets/tours/motorbike/motorbike (3).jpg';
import motorbike4 from './assets/tours/motorbike/motorbike (4).jpg';
import motorbike1 from './assets/tours/motorbike/motorbike (5).jpg';

import phongnha1 from './assets/tours/hue-phongnha/phongnha (1).jpg';
import phongnha2 from './assets/tours/hue-phongnha/phongnha (2).jpg';

import myson1 from './assets/tours/myson/myson (1).jpg';
import myson2 from './assets/tours/myson/myson (2).jpg';
import myson3 from './assets/tours/myson/myson (3).jpg';
import myson4 from './assets/tours/myson/myson (4).jpg';
import myson5 from './assets/tours/myson/myson (5).jpg';

import baidinh1 from './assets/tours/baidinh-trangan/baidinh-trangan (1).jpg';
import baidinh2 from './assets/tours/baidinh-trangan/baidinh-trangan (2).jpg';
import baidinh3 from './assets/tours/baidinh-trangan/baidinh-trangan (3).jpg';
import baidinh4 from './assets/tours/baidinh-trangan/baidinh-trangan (4).jpg';
import baidinh5 from './assets/tours/baidinh-trangan/baidinh-trangan (5).jpg';

import cucphuong1 from './assets/tours/hoalu-cucphuong/cucphuong (1).jpg';
import cucphuong2 from './assets/tours/hoalu-cucphuong/cucphuong (2).jpg';
import cucphuong3 from './assets/tours/hoalu-cucphuong/cucphuong (3).jpg';
import cucphuong4 from './assets/tours/hoalu-cucphuong/cucphuong (4).jpg';
import cucphuong5 from './assets/tours/hoalu-cucphuong/cucphuong (5).jpg';

import battrang1 from './assets/tours/hanoi-battrang/battrang (1).jpg';
import battrang2 from './assets/tours/hanoi-battrang/battrang (2).jpg';
import battrang3 from './assets/tours/hanoi-battrang/battrang (3).jpg';
import battrang4 from './assets/tours/hanoi-battrang/battrang (4).jpg';
import battrang5 from './assets/tours/hanoi-battrang/battrang (5).jpg';

import placesSG from './assets/places/saigon.jpg';
import placesDN from './assets/places/danang.jpg';
import placesHN from './assets/places/hanoi.jpg';
import placesPQ from './assets/places/phuquoc.jpg';

// Icons
import GlobeAltIcon from './assets/globe.svg';
import MoneyIcon from './assets/money.svg';
import StarIcon from './assets/star.svg';
import HeartIcon from './assets/heart.svg';

import hotelIcon from './assets/hotel.svg';
import ticketIcon from './assets/ticket.svg';
import rentalsIcon from './assets/rentals.svg';
import toursIcon from './assets/tours.svg';
import guideIcon from './assets/guide.svg';
import visaIcon from './assets/visa.svg';

import VisaIcon from './assets/visa.svg';
// import TranportIcon from './assets/car.svg';
import WeatherIcon from './assets/weather.svg';
import SafetyIcon from './assets/safety.svg';
import HistoryIcon from './assets/history.svg';
import thaiFlag from './assets/flags/thai.png';
import malaysiaFlag from './assets/flags/malaysia.png';
import singaporeFlag from './assets/flags/singapore.png';
import indoFlag from './assets/flags/indonesia.png';
import camFlag from './assets/flags/cambodia.png';
import laoFlag from './assets/flags/laos.png';
import phFlag from './assets/flags/philippine.png';
import myFlag from './assets/flags/myanmar.png';
import BruneiFlag from './assets/flags/brunei.png';
import skFlag from './assets/flags/southKorea.png';
import jpFlag from './assets/flags/japan.png';

import russiaFl from './assets/flags/russia.png';
import swedenFl from './assets/flags/sweden.png';
import danmarkFl from './assets/flags/denmark.png';
import finlandFl from './assets/flags/findland.png';
import norwayFl from './assets/flags/norway.png';
import ukFl from './assets/flags/uk.png';
import franceFl from './assets/flags/france.png';
import germanyFl from './assets/flags/germany.png';
import spainFl from './assets/flags/spain.png';
import italyFl from './assets/flags/italy.png';
import belarusFl from './assets/flags/italy.png';

import historyImg1 from './assets/tips/history/history1.jpg';
import historyImg2 from './assets/tips/history/history2.jpg';
import historyImg3 from './assets/tips/history/history3.jpg';
import historyImg4 from './assets/tips/history/history4.jpg';
import historyImg5 from './assets/tips/history/history5.jpg';
import historyImg6 from './assets/tips/history/history6.jpg';
import historyImg7 from './assets/tips/history/history7.jpg';

import japaneseBridgeImg from './assets/places/hoian/japaneseBridge.jpg';
import yellowWallsImg from './assets/places/hoian/yellowWalls.jpg';
import yellowWallsImg1 from './assets/places/hoian/yellowWalls1.png';
import yellowWallsImg2 from './assets/places/hoian/yellowWalls2.jpg';
import lanternsImg from './assets/places/hoian/lanterns.jpg';
import faifoImg from './assets/places/hoian/faifo.jpg';
import warMeseumImg from './assets/places/saigon/warMuseum.jpg';
import puppetShowImg from './assets/places/saigon/puppetShow.jpg';
import oldQuartersImg from './assets/places/hanoi/oldQuarters.jpg';
import literatureTempleImg from './assets/places/hanoi/literatureTemple.jpg';
import mausoleumImg from './assets/places/hanoi/hcmmauseleum.jpg';
import ethnologyMuseumImg from './assets/places/hanoi/ethnologyMuseum.jpg';
import hoangkiemImg from './assets/places/hanoi/hoangkiem.jpg';
import beachesImg from './assets/places/danang/beaches.jpg';
import sontraImg1 from './assets/places/danang/sontra1.jpg';
import sontraImg2 from './assets/places/danang/sontra2.jpg';
import haivanImg from './assets/places/danang/haivan.jpg';
import dragonBridgeImg from './assets/places/danang/dragonBridge.jpg';
import banaImg1 from './assets/places/danang/bana1.jpg';
import banaImg2 from './assets/places/danang/bana2.jpg';
import saoBeachImg from './assets/places/phuquoc/saoBeach.jpg';
import baidaiBeachImg from './assets/places/phuquoc/baidaiBeach.jpg';
import anthoiImg from './assets/places/phuquoc/anthoi.jpg';
import fishsauceImg from './assets/places/phuquoc/fishsauce.jpg';
import dinhcauImg from './assets/places/phuquoc/dinhcau.jpg';
import muonghoaImg from './assets/places/sapa/muonghoa.jpg';
import fansipanImg1 from './assets/places/sapa/fansipan1.jpg';
import fansipanImg2 from './assets/places/sapa/fansipan2.jpg';
import hamrongImg from './assets/places/sapa/hamrong.jpg';
import bachaMarhetImg from './assets/places/sapa/bachaMarket.jpg';
import fansipanImg3 from './assets/places/sapa/fansipan3.jpg';
import fansipanImg4 from './assets/places/sapa/fansipan4.jpg';

import glassBridgeImg from './assets/blogs/glassBridge.jpg';
import travelLeisureImg from './assets/blogs/travelLeisure.jpg';
import reutersImg from './assets/blogs/reuters.jpg';

export const tours = [
  {
    id: 1,
    name: 'Halong Bay',
    price: '$175',
    imageSrc: halong1,
    imageAlt: 'West Lake in Hanoi',
    images: [halong1, halong2, halong3, halong4, halong5],
    region: 'Halong',
    duration: '2D1N',
    startDate: 'Everyday',
    description: `You will not only explore one of the most beautiful caves in Halong Bay but will also have the chance to go kayaking or bamboo boat rowing, as well as visiting and interacting with people at a local fishing village.`,
    itinerary: [
      {
        highLight: `Hanoi - Halong Bay - Daragon Cruise - Fishing Village - Thien Cung cave`,
        details: [
          `07:30 - 8:30 Meet our tour guide and bus then take a 3.5-hour bus drive through fertile rice fields to Ha Long Bay. Have a break en-route in Hai Duong City to free your legs.`,
          `12:30 Board our Dragon Cruise and start cruising among limestone islands and photograph of stunning landscapes of Ha Long.`,
          `13:00 Savor your lunch on board while passing by beautiful Stone Dog, Incense Burner islets. `,
          `14:00 Stop at a fishing village to see local fish-men community and know more about their life. Cruising further to take photos of Ha Long Bay symbol, a “Fighting cock” rock.`,
          `15:00 Visit Thien Cung “Heavenly Palace” cave, the most beautiful in Ha Long Bay. Get back and cruise more around emerald water. `,
          `16:15 Stop at the harbor again to catch the bus to Hanoi. `,
          `20:00 Arrive back in Hanoi. Tour ends.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],

    averageRating: 5,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 5,
        title: 'Great service from Reverie travel',
        comment: 'Best tour ever!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },
  {
    id: 2,
    name: 'Bana Hill',
    price: '$105',
    imageSrc: bana1,
    imageAlt: 'Golden bridge in Bana hills',
    images: [bana1, bana2, bana3, bana4, bana5],
    region: 'DaNang',
    duration: '1 day',
    startDate: 'Everyday',
    description: `Escape on Ba Na hills tour from Da Nang city and spend the day on the beautiful Ba Na Hills. Marvel at the exquisite architecture of the Linh Ung Pagoda, Golden Bridge feeling refreshingly cool weather and gorgeous countryside views.`,
    itinerary: [
      {
        highLight: `Danang - Bana Hill - Danang`,
        details: [
          'Depart for Ba Na Hills, pass the sea-shore on Nguyen Tat Thanh street, one of the most beautiful roads of Da Nang City and Red Beach, where the French first landed in Da Nang.',
          `Arrive the cable car station at the foot of Bà Nà Mountain. Enjoy the first leg Cable car, which achieve two Guinness World Records in 2009, longest non-stop cable car (5,042m) and highest non-stop cable car (1,292m).`,
          `Sitting in the cabin, in mid air, looking upon the endless tree line of the forests, bring you with spectacular views of the lush jungle and Fairy waterfalls along the way.`,
          `Experiencing the pristine ecological system of the Bà Nà Mountains will leave you a sense of unforeseeable discovery.Visit the Le Jardin, old wineries, remains of French Villas and Linh Ung Pagoda with 27m high Buddha statue.`,
          `Leave the Le Jardin for the second cable car station to visit the top of mountain and see the remains of old villas.`,
          `Conquer the Peak of Chua Mountain at the height of 1.487m. View the whole Da Nang City under the cluster of white clouds. Leave Peak of Chua Mountain, visit the trail of Dreaming Stream, Rainbow Waterfall, Suspension Bridge, Golden Valley, and ruined Opera House.`,
          `Have a sightseeing and enjoy many games at Fantasy Park (fee extra,  the greatest indoor entertainment in Viet Nam).Have lunch at restaurant, play with wild monkeys and take photos.Return to cable car station at the foot of Ba Na Mountain. Back to Da Nang City. End of services.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 4,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 4,
        title: 'We had a great time visiting Vietnam',
        comment: 'Golden Bridge in Bana looks so awesome!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },

  {
    id: 3,
    name: 'Sapa 2 Days 1 night',
    price: '$575',
    imageSrc: sapa1,
    imageAlt: 'People walking along rice field in Sapa',
    images: [sapa1, sapa2, sapa3, sapa4, sapa5],
    region: 'Sapa',
    duration: '2D1N',
    startDate: 'Everyday',
    description: `Trekking Sapa is the best way to see the countryside of this town. During a trek, you will navigate the hills and mountains to see the beautiful landscape of rice paddies and the traditional villages in Sapa.`,
    itinerary: [
      {
        highLight: `Hanoi – Sapa – Cat Cat – Sapa`,
        details: [
          `6:30 - 7:00 – Our driver and tour guide will come and pick you up at your hotel in Hanoi to depart for Sapa.`,
          `10:00 – Follow the highway to Lao Cai City with a comfortable short break on the way to Sapa.`,
          `13:00 – Arrive at Sapa town and be amazed by the colorful traditional costumes of H’mong, Dzao, Tay ethnic people. Enjoy welcome drinks and itinerary briefing. Then, have lunch with local Vietnamese dishes before the hotel check-in.`,
          `14:30 – Start hiking downhill to Cat Cat village at the bottom of Muong Hoa Valley. Enjoy the spectacular views of the beautiful valley towards Fansipan – the highest peak in Vietnam and Indochina. Upon arrival at the village, you will have a chance to visit the Black H’mong’s traditional stilt houses as well as watch people weaving, embroidering, and drying their clothes, etc. Then, keep walking to visit the dramatic and picturesque Cat Cat Waterfall, which is a great spot for photo-shoots.`,
          `17:00 – Return to Sapa town for dinner. Enjoy your free time in the afternoon to explore Sapa Market and town.`,
          `Overnight at the hotel `,
        ],
      },
      {
        highLight: `Sapa – FANSIPAN - Hanoi`,
        details: [
          `8:00 – Have breakfast at the hotel.`,
          `9:00 Have breakfast and relax at hotel, after driver take you to Fansipan Cable Car Station and spend 20 minutes with cable car to enjoy the spectacular scenery. Reach the altitute of 2800 meters, you have a good time to see the view and take photos, visit pagoda the spiritual destinations and trek up to 600 steps you will reach the peak of Fansipan - the Roof of Indochina. Come back to Fansipan Cable Car Station and return to Sapa town. Have lunch and check in hotel to rest. Take a bus ride to return to Sapa.`,
          `14:30 –Free time in Sapa for refreshment.`,
          `15:15 – Catch a bus to travel back to Hanoi.`,
          `21:15 – Arrive in Hanoi. The tour ends`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 3,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 3,
        title: 'Not so good',
        comment: 'The tour was ok but the food was not delicous at all!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },

  {
    id: 4,
    name: 'Hue City',
    price: '$95',
    imageSrc: hue1,
    imageAlt: 'Hue Citadel',
    images: [hue1, hue2, hue3, hue4, hue5],
    region: 'Hue',
    duration: '1 day',
    startDate: 'Everyday',
    description: `Hue city tour 1 day of  A Travel Mate will bring visitors to many interesting experiences and learn about the history under the 13 feudal dynasties in the Hue Citadel, admire the Imperial architecture or the tomb of  Minh Mang – Tu Duc – Khai Dinh.`,
    itinerary: [
      {
        highLight: `Hue - Dong Ba - Imperial Citadel - Khai Dinh King’s Tomb`,
        details: [
          `Dong Ba Market to see the daily life of local people.`,
          `Dragon boat trip to Thien Mu pagoda - The oldest pagoda in Hue city.`,
          `Imperial Citadel – The home of Vietnam's last royal dynasty - the Nguyen Dynasty.`,
          `Hue Royal Antiques Museum - A collection of ornaments from the Nguyen dynasty.`,
          `Lunch at local restaurant.`,
          `Khai Dinh King’s Tomb - a blend of Western and Eastern architecture.`,
          `Minh Mang King’s Tomb, one is impressed by the majesty and symmetry of the architectural constructions.`,
          `Conical hat village`,
          `4:00 – 4:30 pm:  Back to your hotel. Tour ends.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 5,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 5,
        title: 'So beautiful',
        comment: 'We had a great time visting Hue! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },

  {
    id: 5,
    name: 'Mekong Delta',
    price: '$55',
    imageSrc: mekong1,
    imageAlt: 'Mekong Delta floating market',
    images: [mekong1, mekong2, mekong3, mekong4, mekong5],
    region: 'Mekong',
    duration: '1 day',
    startDate: 'Everyday',
    description:
      'Experience the peace and tranquility of life along the Mekong Delta during this day cruise from Ho Chi Minh City. Escape the hustle of urban streets and relax into the scenic countryside as you tour the watery landscape of southern Vietnam.',
    itinerary: [
      {
        highLight: `HCM City - Mekong - HCM City`,
        details: [
          `Discover the vibrant tropical fruits, gardens, riverside locals, and boat ports as you cruise down the canals of the Mekong Delta. In your wooden river boat, watch the passing homes on stilts, boat making workshops, and vendors along this scenic riverside cruise. `,
          `Begin your outing with a convenient hotel pick up, and then make your way to My Tho City. Watch as the bustling city views transition to serene rice fields and rural settings. On the way, you will have a visit at the Vinh Trang Pagoda. Upon your arrival, take a peaceful boat trip along the Tien River to Qui, also known as Tortoise Islet. This islet is also known by many other name.`,
          `Following, enter the Bao Dinh Canal to head into Ben Tre Province, or the country of coconuts. Here, learn about the local agricultural model known as Garden-Pond-Cage. Taste some local treats like coconut candy and honey tea as you sit back and relax on your wooden river boat in the comfort of the shaded canals covered by water-coconut trees.`,
          `At midday, break for an authentic Vietnamese meal at a local restaurant to taste the region's traditional flavors. Afterwards, board your boat for an afternoon cruise to visit the marvelous tropical fruit gardens and to enjoy a Southern Vietnamese folk music performance by local islanders. After a relaxing cultural experience on the water, you are conveniently transported back to your Ho Chi Minh hotel.`,
          `Note: there is bicycle available for free at the place where you have lunch so you can grab it and bike around the area. Remember not to go so far away to prevent loss on direction`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 5,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 5,
        title: 'So beautiful',
        comment: 'We had a great time visting Vietnam! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },
  {
    id: 6,
    name: 'Cu Chi Tunnel',
    price: '$85',
    imageSrc: cuchi5,
    imageAlt: 'People having fun in Cu Chi tunnels',
    images: [cuchi1, cuchi2, cuchi3, cuchi4, cuchi5],
    region: 'HCM City',
    duration: '1/2 day',
    startDate: 'Everyday',
    description: `Visit one of southern Vietnam’s top destinations on this 6-hour tour from Ho Chi Minh City to the Cu Chi Tunnels. Learn from your guide about the war and how the north Vietnamese army used the vast network of tunnels.`,
    itinerary: [
      {
        highLight: `HCM City - Cu chi - HCM City`,
        details: [
          'Escape the bustle of the city to explore the rural scenery and the famous Cu Chi Tunnels in Southern Vietnam. Step in the shoes of a Viet Cong fighter, as you climb through an impressive 305-mile (250-km) long tunnel network, and visit a typical gun shooting area.',
          `Enjoy a convenient hotel pickup at from your guide as you depart for Cu Chi. Along the way, watch as the frantic city scenery transitions to a more peaceful, rural setting. Witness passing rice paddy farms, quaint roadside vendors, and increasingly lush greenery.`,
          `Once you arrive, begin with a tour the Cu Chi Tunnels, some of the most famous underground networks of pathways, hideouts, sleeping quarters, meeting rooms, hospitals, and Hoang Cam Stove. These narrow tunnels provide barely enough space for a single person to crawl their way through, though some are now wider to accommodate visitors. Also learn that the mere 10–13 feet (3–4 m) thick level of upper soil can support the bearing weight of a 55 ton (50 mT) tank and the explosive damage of bombs.`,
          `Following, watch an insightful film about the wartime experience before further exploring the tunnel's trap doors and underground quarters. Then make a visit to huge bomb craters left from the war, the Garment-factory Ammunition and Souvenir Shops, and the Museum of Self-made Weapons. Get the exhilarating opportunity to fire a M-15, AK-47, and a carbine rifle at the National Defense Sports Shooting Range for a true wartime experience. Finally, savor the Vietnamese traditional soup, Pho, and a local tapioca recipe before the comfortable ride back to your Ho Chi Minh hotel at around 2:30 PM (for morning session) or around 6:30 PM (for afternoon session).`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 4,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 4,
        title: 'So beautiful',
        comment: 'We had a great time visting Vietnam! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },

  {
    id: 7,
    name: 'Mui Ne Jeep',
    price: '$75',
    imageSrc: muine1,
    imageAlt: 'A man standing on sand dune',
    images: [muine1, muine2, muine3, muine4, muine5],
    region: 'MuiNe',
    duration: '1 Day',
    startDate: 'Everyday',
    description: `The endless white sand beaches; the charming fishing villages, the desert-like dunes and numerous types of rare flora and fauna make Mui Ne an ideal place for anyone seeking an enjoyable escape.`,
    itinerary: [
      {
        hightLight: `Fairy Stream - Fishing Village - White Sand Dune - Yellow Sand Dune`,
        details: [
          '4:30AM: Driver will pick you up at your hotel/ resort by private jeep.',
          `5:15AM: Visiting White sand dunes. At the top of the sand dune, catching the first sunrise of the day. Other activities can be taken: riding quad bike over sand dunes and ostrich riding (at own expense), sliding down sand dunes’ slopes with sand boarding`,
          `6:00AM: Continue with your jeep to visit Red sand dunes, slopes are less steep than the White sand dunes, but great opportunity for taking photo as red color of the sand is great contrast to background scenery.`,
          `7:15AM: Visiting the fishing village, observing the daily lives of fishermen, morning catch is hauled to shore and women are busy sorting out the catch and fishing boats are lining up and waiting to depart.`,
          `7:45AM: Visiting Fairy stream where the small stream running through the middle of the red sand dunes. It is like a mini version of Red Canyon`,
          `8:30AM Returning back to your hotel/resort. Tour end.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 4,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 4,
        title: 'So beautiful',
        comment: 'We had a great time visting Vietnam! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },

  {
    id: 8,
    name: 'Can Gio Island',
    price: '$59',
    imageSrc: cangio3,
    imageAlt: 'Can Gio island',
    images: [cangio1, cangio2, cangio3, cangio4, cangio5],
    region: 'CanGio',
    duration: '1 day',
    startDate: 'Everyday',
    description:
      'Experience the peace and tranquility of life along the Mekong Delta during this day cruise from Ho Chi Minh City. Escape the hustle of urban streets and relax into the scenic countryside as you tour the watery landscape of southern Vietnam.',
    itinerary: [
      {
        hightLight: `Mangrove forest - Monkey Island - Monkey island`,
        details: [
          `8.15am : Depart to Can Gio. At Can Gio Island`,
          `Visiting heaps of the long-tailed monkeys`,
          `Visiting The crocodile farm and other wild animals in mangrove forest`,
          `Speed jungle boat, the climax of tour, take you to the Vietnamese base in the war`,
          `Having Vietnamese style lunch.Free time at swimming pool.`,
          `Relax or walk around for sight-seeing. Drop in public seashore (The 30th April Beach) where lots of street snacks and seafood are available.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
  },

  {
    id: 9,
    name: 'Saigon on a bike',
    price: '$89',
    imageSrc: motorbike1,
    imageAlt: 'People sitting on Vespa',
    images: [motorbike1, motorbike2, motorbike3, motorbike4, motorbike5],
    region: 'HCM City',
    duration: '1 day',
    startDate: 'Everyday',
    description: `Discover local eateries that serve authentic Vietnamese favorites on a half-day street food tour of Ho Chi Minh City. Travel by motorbike with your guide to various locations to sample a range of food and drink, getting an intimate experience of Vietnam's vibrant street life along the way.`,
    itinerary: [
      {
        hightLight: `Vibrant streets of Ho Chi Minh City - Food tour by motorbike`,
        details: [
          `Discover local eateries that serve authentic Vietnamese favorites on a half-day street food tour of Ho Chi Minh City. `,
          `Half-day food tour by motorbike in Ho Chi Minh City`,
          `Travel by motorbike with your guide to various locations to sample a range of food and drink, getting an intimate experience of Vietnam's vibrant street life along the way.`,
          `Try different Vietnamese dishes at local eateries`,
          `Experience the vibrant streets of Ho Chi Minh City`,
          `Includes food, guide, and hotel pickup and drop-off`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 4,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 4,
        title: 'So beautiful',
        comment: 'We had a great time visting Vietnam! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },
  {
    id: 10,
    name: 'Hue - Phong Nha',
    price: '$355',
    imageSrc: phongnha1,
    imageAlt: 'Hue',
    images: [phongnha1, phongnha2, hue1, hue2, hue3],
    region: 'Hue',
    duration: '2D1N',
    startDate: 'Everyday',
    description: `On this Phong Nha Caves tour from Hue, you’ll explore the UNESCO-listed complex of 14 grottoes in the limestone mountains of Ke Bang National Park. Used by the Cham people in the ninth and 10th centuries as Buddhist sanctuaries, the caves still contain the remains of altars and inscriptions.`,
    itinerary: [
      {
        highLight: `HUE – PHONG NHA CAVE – DONG HOI`,
        details: [
          `06:30. Tour guide of our company will pick up at your hotel. Move to the National park of Phong Nha – Ke Bang – classified as the world heritage site, stop over at La Vang Church and pass over some famous places DMZ : Hien Luong Bridge, Ben Hai river, Doc Mieu Based. `,
          `11:45. Have lunch at restaurant`,
          `13:00. Boat trip on Son river to discover Phong Nha Cave, visit the caves named Cung Dinh grotto, Tien grotto.`,
          `15:30. Back to Dong Hoi city, check in hotel and free to explore Dong Hoi by night.`,
        ],
      },
      {
        highLight: `DONG HOI – PARADISE CAVE – HUE `,
        details: [
          `In the morning: Enjoy the breakfast with local food at hotel.`,
          `10:30. Pick you up at your hotel in Dong Hoi transfer to Phong Nha.`,
          `11:45. Have lunch at restaurant. The golf cars will take you to Paradise cave in the ecological tourist zone of Paradise cave. Is like “ the Eden on the earth”. The special stalagmites, stalactites system with sparkling, mysterious beauty, out of human beings imagination. Tis spectacular and magical beauty are welcome visitors to come and enjoy.`,
          `15:30. Back to Hue on Ho Chi Minh road ( Historical road in Vietnamese war)`,
          `19:30. We arrive in Hue and drop you off at your hotel.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 4,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 4,
        title: 'So beautiful',
        comment: 'We had a great time visting Vietnam! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },
  {
    id: 11,
    name: 'My Son Holy Land',
    price: '$79',
    imageSrc: myson1,
    imageAlt: 'MySon sanctuary',
    images: [myson1, myson2, myson3, myson4, myson5],
    region: 'MySon',
    duration: '1 Day',
    startDate: 'Everyday',
    description: `This tour is a great offer to help guests BEAT THE CROWDS, AVOID THE HEAT and the risks of covid 19 from large groups. A professional English speaking guide who grew up near the sanctuary as a local will deliver most interesting stories and cultural values of the site.`,
    itinerary: [
      {
        highLight: `HOI AN - MY SON HOLYLAND – TRADITIONAL VILLAGE`,
        details: [
          `This tour is a great offer to help guests BEAT THE CROWDS, AVOID THE HEAT and the risks of covid 19 from large groups. A professional English speaking guide who grew up near the sanctuary as a local will deliver most interesting stories and cultural values of the site.`,
          `Early morning is the best time to capture the most stunning photos at the sanctuary.`,
          `Guests will not only learn about Champa culture and local lives, traditional and cultural practice, the Vietnam war, etc... This can not be achieved by any other suppliers.`,
          `After visiting, taking the best photos and listening to historic stories of the ancient temples from the unique guide, visitors will take a rest in a local home restaurant and have breakfast and coffee (included).`,
          `Then travelers will be dropped back to the hotels and save much time for other activities.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 4,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 4,
        title: 'So beautiful',
        comment: 'We had a great time visting Vietnam! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },

  {
    id: 12,
    name: 'Bai Dinh - Trang An',
    price: '$75',
    imageSrc: baidinh1,
    imageAlt: 'People walking along rice field in Sapa',
    images: [baidinh1, baidinh2, baidinh3, baidinh4, baidinh5],
    region: 'TrangAn',
    duration: '1 Day',
    startDate: 'Everyday',
    description: `With hundreds of big and small statutes, numerous categories of architectural works, Bai Dinh – Trang An combined complex is one of the biggest in Vietnam and has become a must–see place for almost travelers these days.`,
    itinerary: [
      {
        highLight: `HANOI - BAI DINH PAGODA - TRANG AN ECO TOURISM`,
        details: [
          `07:40 – 8:30 Get picked up by our tour guide and bus at your addresses around Hanoi Center then depart for Bai Dinh pagoda and Trang an eco-tourism attraction area (120kms south of Hanoi).`,
          `10:30 Arrive in Buddha Sanctuary place of Bai Dinh Pagoda, the biggest one in Vietnam with 500 Arhan statues. You can see a biggest bronze Buddha statue in Vietnam with 10 meters in height, 100 tons in weight. Tour guide also gives you an introduction of beliefs and religions in Vietnam.`,
          `12:30 Have lunch in a local restaurant with some special dishes such as goat meat, pork storage vessel…`,
          `13:30 Leave for Trang An eco-tourism attraction. You will be amazed by neglected area while having boat trip through cave chains: Sang Cave, Toi Cave, Ba Giot Cave, Sinh Cave…experiencing mysterious views of  the so-called “Ha Long Bay in land”`,
          `16:00 Get back to the bus and then return to Hanoi.`,
          `18:30 Back in Hanoi, you get dropped off at your address. Tour ends.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 4,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 4,
        title: 'So beautiful',
        comment: 'We had a great time visting Vietnam! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },

  {
    id: 13,
    name: 'Hoa Lu - Cuc Phuong',
    price: '$95',
    imageSrc: cucphuong2,
    imageAlt: 'People walking along rice field in Sapa',
    images: [cucphuong2, cucphuong1, cucphuong3, cucphuong4, cucphuong5],
    region: 'HoaLu',
    duration: '1 Day',
    startDate: 'Everyday',
    description: `Cuc Phuong is now the biggest and the most diverse Park in Vietnam with a variety of rare fauna and flora in limestone mountain forest. The Endangered Primates Rescued Centre (EPRC) in the park is an interesting place to see many kinds of rare primates such as Langur, Gibbon and Loris all over Vietnam. Many of them are under threat of extinction.`,
    itinerary: [
      {
        highLight: `Hanoi - Hoa Lu - Tam Coc`,
        details: [
          `07:30 - 8:30 Tour guide pick you up at your hotel then depart for ancient citadel of Hoa Lu (90 km south of Hanoi).`,
          `11:00 Visit temples dedicated to King Dinh Tien Hoang (923-979) and Le Dai Hanh (941-1005). Tour guide give you an introduction of Vietnam history in 10th century.`,
          `12:00 Continue bus drive to Tam Coc for lunch. On the way take pictures of villages and the stunning landscapes.`,
          `13:30 Board on sampans to visit Tam Coc (Three caves). The boat trip through enormous limestone karsts jutting out from the green rice fields leave a good memory.`,
          `15:30 Finishing 2 hours on sampan, check in hotel. Relax in hotel after long day of activity.`,
          `17:00 Dinner at your hotel and stay overnight in Tam Coc.`,
        ],
      },
      {
        highLight: `Tam Coc - Cuc Phuong - Hanoi `,
        details: [
          `07:00 Enjoy morning tea/coffee then have breakfast at your hotel restaurant.`,
          `07:40 Depart for Cuc Phuong National Park, photographing spectacular views through countryside road.`,
          `09:20 Visit Endangered Primate Rescue Center which homes to species like Golden-headed Langur, Tonkin Snub-nosed Langur and Black Crested Gibbon…`,
          `10:30 Experience thrilling moments when exploring Cave of Pre-historic Man dated back 7000 years old.`,
          `11:30 Enjoy a local style Vietnamese lunch at the National Park Headquarters.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 4,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 4,
        title: 'So beautiful',
        comment: 'We had a great time visting Vietnam! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },
  {
    id: 14,
    name: 'Hanoi - Bat Trang',
    price: '$75',
    imageSrc: battrang1,
    imageAlt: 'People walking along rice field in Sapa',
    images: [battrang1, battrang2, battrang3, battrang4, battrang5],
    region: 'HaNoi',
    duration: '1 Day',
    startDate: 'Everyday',
    description: `Bat Trang was known as a famous ceramic producing village formed in 14th century. The village is located near by the Red River which is close to Hanoi city. Bat Trang became the center of ceramic making because of the rich deposition of white clay.`,
    itinerary: [
      {
        highLight: `HA NOI CITY - BAT TRANG CERAMICS VILLAGE TOUR`,
        details: [
          `07:45 - 8:30 Get picked up by our tour guide and bus then visit first place named Tran Quoc pagoda. Experience our national heritage and the beautiful Buddhist relics on the West Lake.`,
          `09:30 Visit a sacred place to recall President Ho Chi Minh’s life and career in Ho Chi Minh’s Mausoleum, the Stilt-house where Ho Chi Minh lived and worked from 1958 to 1969.`,
          `10:30 Visit One Pillar Pagoda, the one modeled after a lotus flower, a symbol of Hanoi city in present days.`,
          `11:00 Visit the Temple of Literature, considering the first university of Viet Nam. The temple was first constructed in 1070 under King Ly Nhan Tong and dedicated to Confucius, sages and scholars.`,
          `12:30 Have Vietnamese lunch at a local restaurant in Hanoi Old Quarter and relax.`,
          `13:30 Continue exploring the daily life of traditional ceramics village of Bat Trang. Visit the pottery showrooms and see how they modeled the products.`,
          `14:30 Drive back to Hoan Kiem lake to visit Ngoc Son Temple dedicated to Van Xuong Saint and Tran Hung Dao General Commander for his struggle against Mongolians.`,
          `15:30 Arrive back your hotel. Tour ends.`,
          `CYCLO RIDE (optional): Pay extra 100,000 VND per person.`,
          `Riding on a cyclo for one hour around the Old Quarter will bring you a wonderful memory in Hanoi.`,
        ],
      },
    ],
    included: [
      'Modern air-con transport, pick-up and drop-off at hotel.',
      'Meals as mentioned in the itineraries.',
      'All entrance fees',
      `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
      'Mineral Water (2 bottles/person)',
      'Insurance',
    ],
    excluded: [
      'Beverages and other meals are not mentioned in the program.',
      'Visa fees to Vietnam',
      `Personal Expenses (laundry, telephone, shopping…)`,
      'Tip/Gratuity',
      `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
    ],
    cancellationPolicy: [
      `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
      `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
      `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
    ],
    confirmationPolicy: [
      `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
      `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
      `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
    ],
    additionalInfo: [
      `Infants must sit on laps`,
      `Children must be accompanied by an adult`,
      `Please advise any specific dietary requirements at time of booking`,
      `Not wheelchair accessible`,
      `Not recommended for pregnant travelers`,
      `Children under 18 cannot book this tour alone`,
      `This tour/activity will have a maximum of 50 travelers`,
      `Operated by Reverie Travel`,
    ],
    averageRating: 4,
    numReviews: 1,
    reviews: [
      {
        _id: '620cfc4608c82135e823a357',
        rating: 4,
        title: 'So beautiful',
        comment: 'We had a great time visting Vietnam! We will come back soon!',
        product: '620486f7facd223de7588b53',
        createdAt: '2022-02-16T13:29:42.150Z',
        updatedAt: '2022-02-16T13:29:42.150Z',

        user: {
          email: 'namnguyen@gmail.com',
          name: 'Nam Nguyen',
          role: 'customer',
          _id: '620486f7facd223de7588b4d',
        },
      },
    ],
  },
];

export const placesToGo = [
  {
    id: 1,
    name: 'Saigon',
    imageSrc: placesSG,
    description: [
      'Still often referred to by its old name, Saigon, Ho Chi Minh City is a clamorous, chaotic sensory feast. Motorbikes honk in a tidal wave across clogged intersections, locals crouch on street corners slurping steaming hot bowls of Pho (noodle soup); and the sultry air is thick with exhaust fumes and exotic spices.',
      `Ho Chi Minh City is Vietnam's commercial hub and largest city, and it's a place where old abuts new with striking contrast. Temples huddle amid skyscrapers and designer shops; locals cast bamboo fishing rods into the languorous Saigon River; and in places, the city feels almost European, with its elegant French colonial architecture and wide, tree-lined avenues.`,
      `Adding to the fascinating cultural jolt is a clutch of intriguing tourist attractions, from the poignant War Remnants Museum and captivating water puppet shows to colorful markets and the time warp of the Reunification Palace.`,
    ],
    places: [
      {
        id: 1,
        name: 'Cu Chi Tunnels',
        description: [
          `About 60 kilometers from Ho Chi Minh City, the Cu Chi Tunnels are a must-see half-day trip and one of the top tours for visitors to the city. This vast 250-kilometer-plus network of tunnels served as the base for the Viet Cong's military operations during the Vietnam War. `,
          `A visit usually includes the chance to crawl through part of the tunnel network, an experience that enhances your appreciation for the stamina and adaptability of the soldiers who lived here.`,
          `Even if you're not a fan of modern military history, the tunnels offer powerful insight into the conditions faced by troops during the conflict and the strategies that strengthened the VC's resistance against American forces.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: cuchi1,
            imageAlt: 'Cu Chi Tunnels',
          },
        ],
      },
      {
        id: 2,
        name: 'War Remnants Museum',
        description: [
          'The War Remnants Museum is one of the most popular museums in Vietnam, with harrowing exhibits related to the horrors of war in this battle-worn nation. The museum primarily focuses on the Vietnam War, however, some exhibits relate to the first Indochina War with French colonialists.',
          'Most of the displays are photographic images, and some of these are confronting – especially the graphic shots of child Agent Orange victims. Artifacts on display include a guillotine and the "tiger cages" used for Viet Cong prisoners.',
          `Period military vehicles and weapons are displayed in the museum's courtyard. After touring the countryside and the Cu Chi Tunnels, you'll find these exhibits even more moving, but note that some of the exhibits are not suitable for small children.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: warMeseumImg,
            imageAlt: 'War Remnants Museum',
          },
        ],
      },
      {
        id: 3,
        name: 'Mekong Delta',
        description: [
          'Cruising through the lush labyrinth of palm-fringed channels, rivers, and islands of the Mekong Delta is a popular day trip that seems a world away from hectic Ho Chi Minh City. It offers a fascinating glimpse into the way of life of the people who depend on this fragile waterway for their survival.',
          `Encompassing about 40,000 square kilometers, the delta produces more than half of the country's grain and 90 percent of its exports, and it's well-known for its floating markets, which usually take place during the early morning.`,
          `From Ho Chi Minh City, tours to the delta, usually involve a 70-kilometer drive to My Tho, a market town on the banks of the Mekong River; a cruise along the delta; and visits to local villages, farms, and factories. The Mekong Delta Discovery Small Group Adventure Tour offers these activities, as well as the chance to sample traditional dishes and tropical fruit from the region.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: mekong1,
            imageAlt: 'Mekong Delta',
          },
        ],
      },
      {
        id: 4,
        name: 'Golden Dragon Water Puppet Theatre',
        description: [
          'The Golden Dragon Water Puppet Theatre is perfect for families with young children and anyone who enjoys light-hearted traditional entertainment. Water puppetry originated in rural villages in the Red River Delta and has been performed in Vietnam for more than 1,000 years.',
          `The captivating 50-minute show provides a window into the country's culture. It's presented in Vietnamese, but the strength of the puppet characters, both people and animals, transcends the language barrier.`,
          `Live music enhances the experience; the talented musicians play traditional instruments such as bamboo flutes and two-stringed violins. The theater is air-conditioned, and if you're sitting in the front row, be prepared for some gentle splashes.`,
        ],
        images: [
          { id: 1, imageSrc: puppetShowImg, imageAlt: 'water puppet show' },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'Hanoi',
    imageSrc: placesHN,
    description: [
      `Dive into Hanoi's pulsating city streets, and you'll capture the essence of Vietnamese life. The country's capital is a burgeoning economic center that still clings strongly to traditional culture, managing to be a showcase of both old and modern Vietnam.`,
      `The old quarter district hums with street vendor action; the cafés and restaurants are vibrant, contemporary scenes; and just trying to cross a road here can end up being an adrenaline-fueled escapade.`,
      `When the crowds begin to wear you down, Hanoi has a bundle of places to visit where you can escape for some peace. Hoan Kiem Lake is a relaxing respite right within the city, while the Temple of Literature and Vietnam Museum of Ethnology provide plenty of opportunities to reflect on Vietnam's grand history.`,
    ],
    places: [
      {
        id: 1,
        name: 'Hanoi Old Town Quarter',
        description: [
          'The Japanese Covered Bridge was built in the 16th century to connect the Chinese and Japanese quarters of the Vietnamese city. It is now such an iconic landmark of Hoi An City and Vietnam itself that it features on the 20,000 VND note. A temple on the north side is dedicated to the Taoist God of weather, lending the bridge its Vietnamese name: Chùa Cầu, the temple bridge.',
          'Visit early in the morning to beat the crowds and cross the bridge without paying a fee. Photos of the inside are historically interesting, with its Chinese script and its monkey and dog statue guardians. Photos of the bridge’s outside captured the delicate beauty of its architecture.',
          'During the daytime you can get good pictures of its fine details: carved dark wood trimmed with red lacquer and gold and stretched between two shorelines of sunshine-yellow walls. At night, the bridge glows with diffuse colored lighting, casting a crisp reflection into the water below.',
        ],
        images: [
          {
            id: 1,
            imageSrc: oldQuartersImg,
            imageAlt: 'Hanoi Old Town Quarter',
          },
        ],
      },
      {
        id: 2,
        name: 'Hoan Kiem Lake',
        description: [
          `Hanoi's most well-known landmark is tranquil Hoan Kiem Lake, nestled just on the southern edge of the old town quarter. `,
          `The major tourist attraction upon the lake is the small island (reached by a red bridge) that holds Ngoc Son Temple, dedicated to three grand figures from Vietnamese history: La To (revered as a patron saint of physicians); the renowned scholar Van Xuong; and the 13th-century general Tran Hung Dao, who fought against the invading Mongol army.`,
          `Another tiny island on the southern section of the lake holds the stocky Turtle Tower – best viewed from the bridge.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: hoangkiemImg,
            imageAlt: 'Hoan Kiem Lake',
          },
        ],
      },
      {
        id: 3,
        name: 'Temple of Literature',
        description: [
          `The city's most interesting religious building is this beautiful and incredibly peaceful Confucian temple, originally built as a university in the 11th century. Today, the Temple of Literature stands as a tribute to the nation's scholars.`,
          `It was here, in the medieval era, that the philosophy of Confucianism and literature was taught, and near the entranceway, you can still see the names of students who studied here, etched into a series of pillars.`,
          `Inside, a series of manicured gardens lead to pavilions and a well-preserved pagoda where a statue of Confucius sits.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: literatureTempleImg,
            imageAlt: 'temple of literature',
          },
        ],
      },
      {
        id: 4,
        name: ' Ho Chi Minh Mausoleum',
        description: [
          'Perhaps more than anything else, strings of silk lanterns are the most iconic symbols of Hoi An. Imported by the Japanese, who inherited them from the Chinese, these traditional lanterns are now a solidly Vietnamese tradition that has been handcrafted in Hoi An for hundreds of years.',
          'During the daytime, they dangle in bright colors from doorways or stretch across in the glass windows of shopfronts, the antique city’s signature accessory.',
          'Take a picture during the day to capture different shapes, colors, and patterns pressed against yellow walls, but the lanterns really come alive at night. Head to Old Town just before sunset to see everything softly illuminated, pedestrians padding by underway, everyone’s eyes to the sky. When true darkness falls the lanterns glow in high contrast. Early dusk is the magic hour for catching photos of faces illuminated by the lanterns without losing the background to silhouette and shadow.',
        ],
        images: [
          { id: 1, imageSrc: mausoleumImg, imageAlt: ' Ho Chi Minh Mausoleum' },
        ],
      },
      {
        id: 5,
        name: 'Vietnam Museum of Ethnology',
        description: [
          `A must for museum fans and history lovers, Hanoi's Vietnam Museum of Ethnology houses the extensive national collection and tells the story of Vietnam's diverse cultures in a series of excellently well-curated exhibits.`,
          `Here, the huge number of ethnic minorities who call Vietnam home are highlighted with beautiful displays of artifacts and art that showcase wooden carving, metalwork, and traditional costumes.`,
          `The garden area outside the main building holds some of the most interesting exhibits. Here, you can see the rural dwellings used by different ethnic minorities across Vietnam, as well as the fascinating Giarai tomb.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: ethnologyMuseumImg,
            imageAlt: 'Vietnam Museum of Ethnology',
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: 'Danang',
    imageSrc: placesDN,
    description: [
      `Thanks to its central location, vast stretches of beach, and variety of things to do, the coastal city of Da Nang has become something of a tourism hot spot.`,
      `The city, which lies halfway between Hanoi in the North and Ho Chi Minh in the South, is the fifth-largest in Vietnam, and the third most populated. It has an international airport and is a short drive away from Hoi An, making it a great spot for international tourists to stay a few days on a tour of the country.`,
      `Locals and ex-pats living in Vietnam also love this destination for its relaxed lifestyle, burgeoning food scene, and exciting nightlife. Here are just some of the top places to go when you visit Da Nang.`,
    ],
    places: [
      {
        id: 1,
        name: 'THE BEAUTIFUL BEACHES',
        description: [
          'The THE BEAUTIFUL BEACHES was built in the 16th century to connect the Chinese and Japanese quarters of the Vietnamese city. It is now such an iconic landmark of Hoi An City and Vietnam itself that it features on the 20,000 VND note. A temple on the north side is dedicated to the Taoist God of weather, lending the bridge its Vietnamese name: Chùa Cầu, the temple bridge.',
          'Visit early in the morning to beat the crowds and cross the bridge without paying a fee. Photos of the inside are historically interesting, with its Chinese script and its monkey and dog statue guardians. Photos of the bridge’s outside captured the delicate beauty of its architecture.',
          'During the daytime you can get good pictures of its fine details: carved dark wood trimmed with red lacquer and gold and stretched between two shorelines of sunshine-yellow walls. At night, the bridge glows with diffuse colored lighting, casting a crisp reflection into the water below.',
        ],
        images: [
          {
            id: 1,
            imageSrc: beachesImg,
            imageAlt: 'beach in danang',
          },
        ],
      },
      {
        id: 2,
        name: 'SƠN TRÀ PENINSULA',
        description: [
          `When at any of these beaches, look left. You’ll see the beautiful white Lady Buddha statue on the hill. At 67m, the Goddess of Mercy is the tallest Buddha statue in the land. To see it up close, head out to the Linh Ung Pagoda at Sơn Trà Peninsula, a nature reserve about 10km north-east of the city.`,
          `The Sơn Trà (Monkey) Mountain protects the city from approaching sea storms. A hike or ride to the top will reward you with stunning views. `,
          `And you may even spot the endangered Pygathrix nemaeus (red-shanked douc) on the way up. The verdant rainforest surrounding the mountain covers 4,000 hectares, making it a cool, lush alternative to the beach on hot days.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: sontraImg1,
            imageAlt: 'SƠN TRÀ PENINSULA',
          },
          {
            id: 2,
            imageSrc: sontraImg2,
            imageAlt: 'SƠN TRÀ PENINSULA',
          },
        ],
      },
      {
        id: 3,
        name: 'HẢI VÂN PASS',
        description: [
          `Motorbike enthusiasts will be keen to adventure along this mountain pass, which Top Gear presenters raved about in their 2008 Vietnam Special TV show. Jeremy Clarkson said the pass is “a deserted ribbon of perfection—one of the best coast roads in the world”.`,
          `The scenic 21km-long ‘Ocean Cloud’ pass is famous for many reasons. It’s one of the longest and highest in the country. It was a strategic boundary during war times. And it separates the climates of the tropical south from the subtropical north. `,
          `Another reason it’s popular is that it’s easily accessible from Da Nang, Huế, and Hội An. For an epic road trip, ride the pass for 165km between these three cities. Get up early to make a day of it. Or break it up over a couple of days by overnighting en route.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: haivanImg,
            imageAlt: 'haivan pass',
          },
        ],
      },
      {
        id: 4,
        name: 'THE DRAGON BRIDGE',
        description: [
          `Many cities in Vietnam boast beautiful suspension bridges. But Da Nang lays claim to having the longest of these: Dragon Bridge. This six-lane, state-of-the-art bridge features an impressive dragon structure, which locals are rather proud of. Dragons are important symbols in Vietnamese culture, representing growth and the power of the nation.`,
          `At night, the dragon on this bridge is beautifully lit up with LED lights. And, come Saturday and Sunday night at 9 pm, it sprouts fire and water from its mouth in a performance attended by many onlookers. `,
          `Best spots for viewing the show? Get close to the action on the bridge itself. Sit at a café on Trần Hưng Đạo Street. Or grab a seat and a snack at the Sơn Trà night market down below.`,
        ],
        images: [
          { id: 1, imageSrc: dragonBridgeImg, imageAlt: 'THE DRAGON BRIDGE' },
        ],
      },
      {
        id: 5,
        name: 'BÀ NÀ HILLS',
        description: [
          `For a family-friendly day outing, head to Bà Nà Hills. This hilltop resort in the Trường Sơn Mountains is a 40-minute drive to the west. It was first established as a resort by the French back in 1919. While most of the villas were destroyed during the war, the Debay Wine Cellar still remains. `,
          `Purchase tickets to enter the hills in advance, to skip the queues. Your entry includes a round-tip on the impressive cable cars going up and down the mountain. Once there, there are lots to see and do at the themed, castle-like Sun World Amusement Park.`,
          `Walk the flower gardens or French village; visit the Linh Ung temple; or play games at the amusement park. Of course, many people go to take pictures of the famed Golden Bridge. This 150-meter-long architectural marvel features two gigantic concrete hands elegantly holding a shiny gold walkway. Impressive (and Insta-worthy) indeed.`,
        ],
        images: [
          { id: 1, imageSrc: banaImg1, imageAlt: 'BÀ NÀ HILLS' },
          { id: 2, imageSrc: banaImg2, imageAlt: 'BÀ NÀ HILLS' },
        ],
      },
    ],
  },
  {
    id: 4,
    name: 'PhuQuoc',
    imageSrc: placesPQ,
    description: [
      `Phu Quoc: an ‘emerald island’ of white powder beaches, turquoise waters, palm tree forests, mountains, and waterfalls. This Vietnamese island is located close to the coast of Cambodia in the Gulf of Thailand, and half of the island is a stunning national park. Aside from its incredible nature, and paradise beaches, it is also home to bustling markets, and unique food products. `,
      `Hop on a motorbike and get ready for an adventure, with all the top things to do in Phu Quoc.`,
    ],
    places: [
      {
        id: 1,
        name: 'Sao Beach',
        description: [
          `Coming to Phu Quoc, you should not miss Bai Sao, one of the most beautiful beaches here. Bai Sao is only 25km from Duong Dong town, so you can use some popular transportations in Phu Quoc such as motorbikes, cars, or taxis to get there. The beach is named "Sao - Starfish" because when night falls, there are tens of thousands of starfish moving onto the white sand.`,
          `This beach is loved by white sand beaches, clear blue seawater, and a fantastic fresh climate. The rustic but romantic beauty is also a feature that attracts tourists. Please do not forget to visit this beach when traveling to Phu Quoc.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: saoBeachImg,
            imageAlt: 'beach in phuquoc',
          },
        ],
      },
      {
        id: 2,
        name: 'Bai Dai Beach',
        description: [
          `Bai Dai is also one of the most popular tourist destinations in Phu Quoc. Bai Dai is located in the northwest of the island. To get to Bai Dai beach from Duong Dong town, you should travel along DT45 road to Vinmec Hospital will see a path leading down to the Vinpearl resort complex. Just walking along that road, you will reach the beautiful Bai Dai beach.`,
          `Bai Dai is true to its name, stretching more than 20km with clear blue seawater, golden sand, and coconut trees casting shadows at sunset, creating an incredibly poetic scene. With a long stretch of fine golden sand and clear blue sea-like jade, this is considered an ideal beach for all tourists. You can join engaging activities such as kayaking, scuba diving to see corals.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: baidaiBeachImg,
            imageAlt: 'Bai Dai Beach',
          },
        ],
      },
      {
        id: 3,
        name: 'An Thoi Islands',
        description: [
          `An Thoi archipelago is a destination that you should not miss when traveling to Phu Quoc. Coming here, you can take a boat to see the clear blue sea and the beautiful islands. Blue sea - white sand - golden sunshine are the three words that most accurately describe this beautiful island.`,
          `The interesting thing is that you should experience join the fishing tour on a boat. The fish caught will be in the lunch on the ship. In addition, you can swim and snorkel here because Phu Quoc is famous for being the longest and most beautiful coral reef in Vietnam.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: anthoiImg,
            imageAlt: 'An Thoi Islands',
          },
        ],
      },

      {
        id: 4,
        name: 'Fish sauce barrel house',
        description: [
          `The barrel house is the popular name where the handicraft production of concentrated fish sauce is carried out in large wooden crates. People here will prepare more to produce golden drops of fish sauce with the strong smell of anchovies. Phu Quoc fish sauce is famous for its high protein content, beautiful color, and uniquely delicious taste.`,
          `You can visit the barrel houses to learn about the production process of the famous fish sauce here. The price of Phu Quoc fish sauce ranges from 100,000đ - 200,000đ/liter depending on the different protein levels. `,
        ],
        images: [
          {
            id: 1,
            imageSrc: fishsauceImg,
            imageAlt: 'Fish sauce barrel house',
          },
        ],
      },
      {
        id: 5,
        name: 'Dinh Cau Temple',
        description: [
          `Dinh Cau is a must-visit place in Duong Dong town, located on a bizarre cliff reaching out to the sea. This temple worships Thuy Long Thanh Mau, who is said to have openly reclaimed Phu Quoc island. To get Dinh Cau you need to climb 29 meandering stone steps.`,
          `This ancient temple is lying under the big green tree. It is the more nostalgic and mysterious beauty under the sunset, so you should come here late afternoon and enjoy the sunset. Every 15 Oct lunar month, the Dinh Cau festival will be organized and attract thousands of tourists. You can plan to visit this occasion to understand more about festival culture in Vietnam. `,
        ],
        images: [{ id: 1, imageSrc: dinhcauImg, imageAlt: 'Dinh Cau Temple' }],
      },
    ],
  },

  {
    id: 5,
    name: 'Sapa',
    imageSrc: sapa4,
    description: [
      `Sapa is home to stunning mountain landscapes, verdant rice terraces, unique stilt villages and Indochina peak, the Fansipan. The most prominent attraction in the town of Sapa is Fansipan, which is the highest mountain in Vietnam and it is only 19km from town.`,
      `It may seem like a short distance, but the trek is not easy; the rough terrain and unpredictable weather present some difficulties. `,
      ` Tourists who are fit and have mountain climbing experience will enjoy this attraction the most, as the peak is accessible all year round. Technical climbing skills are not necessary, but endurance is a must.`,
    ],
    places: [
      {
        id: 1,
        name: 'Muong Hoa Valley',
        description: [
          'The  was built in the 16th century to connect the Chinese and Japanese quarters of the Vietnamese city. It is now such an iconic landmark of Hoi An City and Vietnam itself that it features on the 20,000 VND note. A temple on the north side is dedicated to the Taoist God of weather, lending the bridge its Vietnamese name: Chùa Cầu, the temple bridge.',
          'Visit early in the morning to beat the crowds and cross the bridge without paying a fee. Photos of the inside are historically interesting, with its Chinese script and its monkey and dog statue guardians. Photos of the bridge’s outside captured the delicate beauty of its architecture.',
          'During the daytime you can get good pictures of its fine details: carved dark wood trimmed with red lacquer and gold and stretched between two shorelines of sunshine-yellow walls. At night, the bridge glows with diffuse colored lighting, casting a crisp reflection into the water below.',
        ],
        images: [
          {
            id: 1,
            imageSrc: muonghoaImg,
            imageAlt: 'muong hoa valley',
          },
        ],
      },
      {
        id: 2,
        name: 'Fansipan Cable Car',
        description: [
          `As of May 11, 2013, cable car to the top of Fansipan was inaugurated on the morning of February 2. This is a modern three-wire cable, the first in Asia presence. The total investment in the first phase of the project is 4,400 billion VND. The distance from the Muong Hoa peaked go through 6 main pillars, each pillar being 1 km.`,
          `The Guinness Book of World Records has awarded two Guinness certification for the Fansipan Sapa, including a three-wire cable car station and the difference between the world’s largest arrivals (1,410 m) cable cars and the world’s longest three-wire (6292.5 m).`,
          `Each cable car cabin can accommodate up to 35 guests, with a transport capacity of up to 2,000 people per hour. The time to go to the gas station to just 15 minutes.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: fansipanImg1,
            imageAlt: 'Fansipan Cable Car',
          },
          {
            id: 2,
            imageSrc: fansipanImg2,
            imageAlt: 'Fansipan Cable Car',
          },
        ],
      },
      {
        id: 3,
        name: 'Ham Rong Mountain',
        description: [
          `Via Muong Tien to get to Sapa, in vaporous clouds travelers will see a mountain peak rising as dragon-head. It is Ham Rong mountain with 100 ha in area.`,
          `The name of Ham Rong was derived from the legend that, in primitive age there were a couple of dragons which became attached to each other while the deluge was rising high. Walking up, they hurrily separated from each other but failed. They were drifted to different places.`,
          `After a long time, the female dragon was petrified but still tried to raise its eyes to the male dragon on the Hoang Lien mountain in the west because its instinct for survival remained.As going to Sapa, travelers often climb up Ham Rong mountain to enjoy a cool atmosphere and charming landscapes such as cloud ground and stone garden, gardens, garden of medicinal plants, especially the garden of various orchids and specific houses on stilts of ethnic minorities.`,
        ],
        images: [
          {
            id: 1,
            imageSrc: hamrongImg,
            imageAlt: 'Ham Rong Mountain',
          },
        ],
      },

      {
        id: 4,
        name: 'Bac Ha Market',
        description: [
          'Perhaps more than anything else, strings of silk lanterns are the most iconic symbols of Hoi An. Imported by the Japanese, who inherited them from the Chinese, these traditional lanterns are now a solidly Vietnamese tradition that has been handcrafted in Hoi An for hundreds of years.',
          'During the daytime, they dangle in bright colors from doorways or stretch across in the glass windows of shopfronts, the antique city’s signature accessory.',
          'Take a picture during the day to capture different shapes, colors, and patterns pressed against yellow walls, but the lanterns really come alive at night. Head to Old Town just before sunset to see everything softly illuminated, pedestrians padding by underway, everyone’s eyes to the sky. When true darkness falls the lanterns glow in high contrast. Early dusk is the magic hour for catching photos of faces illuminated by the lanterns without losing the background to silhouette and shadow.',
        ],
        images: [
          { id: 1, imageSrc: bachaMarhetImg, imageAlt: 'Bac Ha Market' },
        ],
      },

      {
        id: 5,
        name: 'Fansipan Mountain',
        description: [
          `Fansipan is branded “the Roof of Indochina” at the height of 3, 143m; Fansipan Mountain is to be approved as one of the very few eco-tourist spots of Vietnam, with about 2, 024 floral varieties and 327 faunal species.The topography of Fansipan is varied. Muong Hoa Valley, at the lowest altitude (950-1, 000m), is created by a narrow strip of land at the base on the east side of the mountain.`,
          ` It seemed the Fansipan Tour was meant only for those who wished to test their muscular power.The summit of Fansipan is accessible all year round, but the best time to make the ascent is from mid-October to mid-November, and again in March.`,
          `Foreigners like best to book Fansipan tours between October and December, as this period is more often than not free from the heavy rains that obstruct the jaunt. But the Vietnamese prefer their tours to the peak of the mountain from February to April, as it is not so cold then. However, the best time for the trek to the mountain is from the end of February to the start of March, when the flowers all flourish and the climbers may behold the.`,
        ],
        images: [
          { id: 1, imageSrc: fansipanImg3, imageAlt: 'Fansipan Mountain' },
          { id: 2, imageSrc: fansipanImg4, imageAlt: 'Fansipan Mountain' },
        ],
      },
    ],
  },

  {
    id: 6,
    name: 'Hoian',
    imageSrc: japaneseBridgeImg,
    description: [
      'Hoi An has captivated the imaginations of artists and photographers for hundreds of years. In the 18th Century, Hoi An was one of the most important trading ports in the South China Sea. Languages of the world were spoken in its alleyways, artisans swapped materials and inspiration, and Hoianese handcrafts like ceramics were traded as far away as Egypt and Portugal. The ancient town has preserved this dynamic legacy in structures like the Japanese Bridge and Chinese Temples, its architecture a living memory of Japanese and Chinese and European roots.',
      'Free from pollution and vehicle traffic, pedestrians stroll past golden yellow buildings where laughing women squat together to sell fresh food and handicraft from bamboo baskets under strings of silk lanterns. Horizon-bound rice paddies undulate in ten thousand shades of green or reflect the sky back to itself in a mirror of flooded fields.',
      'Hoi An was declared a UNESCO World Heritage Site in 1999, and it retains the weight and heartbeat of its centuries of commerce and culture and dreams. There is something about the city that transforms every guest into an artist or photographer. Here are some of its most photogenic and Instagram-worthy sites and scenes.',
    ],
    places: [
      {
        id: 1,
        name: 'Japanese Covered Bridge',
        description: [
          'The Japanese Covered Bridge was built in the 16th century to connect the Chinese and Japanese quarters of the Vietnamese city. It is now such an iconic landmark of Hoi An City and Vietnam itself that it features on the 20,000 VND note. A temple on the north side is dedicated to the Taoist God of weather, lending the bridge its Vietnamese name: Chùa Cầu, the temple bridge.',
          'Visit early in the morning to beat the crowds and cross the bridge without paying a fee. Photos of the inside are historically interesting, with its Chinese script and its monkey and dog statue guardians. Photos of the bridge’s outside captured the delicate beauty of its architecture.',
          'During the daytime you can get good pictures of its fine details: carved dark wood trimmed with red lacquer and gold and stretched between two shorelines of sunshine-yellow walls. At night, the bridge glows with diffuse colored lighting, casting a crisp reflection into the water below.',
        ],
        images: [
          {
            id: 1,
            imageSrc: japaneseBridgeImg,
            imageAlt: 'Yellow Walls of Hoi An',
          },
        ],
      },
      {
        id: 2,
        name: 'Yellow Walls of Hoi An',
        description: [
          'It is possible to spend hours wandering through the bewitching butter-yellow buttresses of the city, enchanted by goldenrod and canary, sunflower and saffron-hued Hoi An. Hoi An burns itself into the memories and photographs of visitors in this hypnotizing shade of yellow. Get lost in narrow alleys between ancient buildings that wind endlessly through the converging cityscape. ',
          'Blue and green doors and windows bloom open from French balconies. The wear and tear of the paint add charm and character where it reveals raw walls beneath.',
          'There are lots of opportunities in the narrow maze between buildings to play with scale and perspective and contrast. Wear a poppy-red dress to pose brightly against the yellow. Find a pretty spot to sit where you can set up a frame. From here, wait for bicycles or women in ao dai to ride or walk across the golden gallery walls for a truly classic cultural shot.',
        ],
        images: [
          {
            id: 1,
            imageSrc: yellowWallsImg,
            imageAlt: 'Yellow Walls of Hoi An',
          },
          {
            id: 2,
            imageSrc: yellowWallsImg1,
            imageAlt: 'Yellow Walls of Hoi An',
          },
          {
            id: 3,
            imageSrc: yellowWallsImg2,
            imageAlt: 'Yellow Walls of Hoi An',
          },
        ],
      },
      {
        id: 3,
        name: 'Temples in Old Town Hoi An',
        description: [
          'Hoi An is rife with ornate temples built in a collage of architectural influences. All of them offer opportunities for beautiful photography. Pop in and out of garden courtyards, ducking under strings of lanterns and past gold and red Chinese calligraphy and engravings. ',
          'Some temples require a ticket to enter, but many are free. Keep an eye out for Buddhist drums and gongs; for Daoist cosmological symbols and trigrams; ornate gates, engraved altars, and painted doorways; and for carved wooden statues of spirits and dragons.',
          'Some of these buildings date back as far as the 14th and 15th centuries, before Japan, before China, and before Hoi An was even a Vietnamese city. The Hindu-influenced fingerprint of the Champa empire lingers in architectural examples like the My Son Sanctuary.',
        ],
        images: [],
      },
      {
        id: 4,
        name: 'Hoi An Lanterns',
        description: [
          'Perhaps more than anything else, strings of silk lanterns are the most iconic symbols of Hoi An. Imported by the Japanese, who inherited them from the Chinese, these traditional lanterns are now a solidly Vietnamese tradition that has been handcrafted in Hoi An for hundreds of years.',
          'During the daytime, they dangle in bright colors from doorways or stretch across in the glass windows of shopfronts, the antique city’s signature accessory.',
          'Take a picture during the day to capture different shapes, colors, and patterns pressed against yellow walls, but the lanterns really come alive at night. Head to Old Town just before sunset to see everything softly illuminated, pedestrians padding by underway, everyone’s eyes to the sky. When true darkness falls the lanterns glow in high contrast. Early dusk is the magic hour for catching photos of faces illuminated by the lanterns without losing the background to silhouette and shadow.',
        ],
        images: [{ id: 1, imageSrc: lanternsImg, imageAlt: 'Hoi An Lanterns' }],
      },
      {
        id: 5,
        name: 'Faifo Coffee',
        description: [
          'Most of the best shots of Hoi An happen at the street level, but Faifo Coffee shop is a delightful exception. This cafe is one of the only buildings in Hoi An with a rooftop terrace, so the expansive view it offers across the rooftops of the city is truly unique. ',
          'On a bright and sunny day, the yellow buildings with their brown roofs ripple-like sharp and triangular waves against the blue sky, all the way out to the horizon.',
          'The coffee is thankfully as good as the views, so it’s worth waiting for the perfect shot. The rooftop can get crowded with people posing for their own selfies, so be patient and enjoy the atmosphere and the view while you wait for your own photoshoot. That’s the point, anyway, isn’t it?',
        ],
        images: [{ id: 1, imageSrc: faifoImg, imageAlt: 'Faifo Coffee' }],
      },
    ],
  },
];

export const blogs = [
  {
    id: 1,
    imageSrc: glassBridgeImg,
    title: `World's longest glass bridge to open in northern Vietnam`,
    description: `A 632-meter-long glass bridge in northern highlands town Moc Chau, said to be the world's longest, is scheduled to open to tourists during the Reunification Day (April 30) holiday.`,
    url: 'https://e.vnexpress.net/news/places/worlds-longest-glass-bridge-to-open-in-northern-vietnam-4452792.html',
    source: 'VnExpress',
    date: new Date(),
    timeToRead: 7,
  },
  {
    id: 2,
    imageSrc: placesPQ,
    title: 'Vietnam welcomes 1st tourists to resort island after 2 years',
    description:
      'Vietnam has welcomed more than 200 foreign tourists to its largest island, the first to visit the Southeast Asian country after nearly two years of border closure due to the COVID-19 pandemic',
    url: `https://abcnews.go.com/Travel/wireStory/vietnam-welcomes-1st-tourists-resort-island-years-81296435`,
    source: 'ABC News',
    date: new Date(),
    timeToRead: 10,
  },

  {
    id: 3,
    imageSrc: travelLeisureImg,
    title: 'Vietnam Lifts Quarantine, Opens Borders to the World',
    description:
      'All travelers will be required to arrive with proof of a negative COVID-19 PCR or LAMP test taken within 72 hours of their departure or a negative rapid antigen test taken within 24 hours of their departure.',
    url: 'https://www.travelandleisure.com/travel-news/vietnam-lifts-quarantine-requirement',
    source: 'Travel Leisure',
    date: new Date(),
    timeToRead: 8,
  },

  {
    id: 4,
    imageSrc: placesSG,
    title: 'Vietnam Ready to Welcome Back International Tourists',
    description: `Vietnam has launched a new tourism campaign “Live fully in Vietnam” as it welcomes international tourists back into the country or the first time since March 2020. According to a release, “travelers will be able to walk new paths and savor new tastes in Vietnam, to experience the country’s internationally-treasured culture and nature anew.”`,
    url: 'https://www.brandinginasia.com/vietnam-ready-to-welcome-back-international-tourists-launches-live-fully-in-vietnam-campaign/',

    source: 'Brading in Asia',
    date: new Date(),
    timeToRead: 9,
  },
  {
    id: 5,
    imageSrc: reutersImg,
    title: `Vietnam's resort island welcomes first tourists after nearly 2 yrs`,
    description: `HANOI, Nov 20 (Reuters) - Two hundred vaccinated foreign tourists arrived in Vietnam's beach-fringed island of Phu Quoc on Saturday, the first wave of visitors to the country in nearly two years as it seeks to resurrect its pandemic-ravaged tourism economy.`,
    url: 'https://www.reuters.com/markets/asia/vietnams-resort-island-welcomes-first-tourists-after-nearly-2-yrs-2021-11-20/',
    source: 'Reuters',
    date: new Date(),
    timeToRead: 7,
  },

  {
    id: 6,
    imageSrc: placesHN,
    title: `Asia's Leading Destination 2021`,
    description: `Vietnam is announced as “Asia’s Leading Destination 2021” by The World Travel Awards.We are ready to welcome back visitors from all over the world!”`,
    url: 'https://www.worldtravelawards.com/award-asias-leading-destination-2021',
    source: 'WTA',
    date: new Date(),
    timeToRead: 9,
  },
];

export const features = [
  {
    name: 'Diverse Destinations',
    description: 'Flexible Tailor-made Itineraries designed just for you.',
    icon: GlobeAltIcon,
  },
  {
    name: 'Value for Money',
    description: 'Experienced local guides with a passion and great knowledge.',
    icon: MoneyIcon,
  },
  {
    name: 'Beautiful Places',
    description: 'On ground support with modern transportation you need.',
    icon: StarIcon,
  },
  {
    name: 'Passionate Travel',
    description: 'Destination experts behind every journey of Reverie Travel.',
    icon: HeartIcon,
  },
];

export const tips = [
  { id: 1, title: 'visa', icon: VisaIcon },
  { id: 2, title: 'transport', icon: rentalsIcon },
  { id: 3, title: 'weather', icon: WeatherIcon },
  { id: 4, title: 'safety', icon: SafetyIcon },
  { id: 5, title: 'history', icon: HistoryIcon },
];

export const reviews = [
  {
    id: 1,
    imageSrc: halong1,
    name: 'Albus Dumbledore',
    comment:
      'This tour company was amazing! Nam was absolutely fantastic to work with, he arranged everything was open to any changes we wanted to make itinerary before coming. Once in Vietnam he was prompt as responding to any inquires we had. They put the client/traveller first and work with you to create the most memorable trip. :)',
    stars: 5,
    from: 'Tripadvisor',
  },
  {
    id: 2,
    imageSrc: halong2,
    name: 'JK.Rowling',
    comment:
      'This tour company was amazing! Nam was absolutely fantastic to work with, he arranged everything was open to any changes we wanted to make itinerary before coming. Once in Vietnam he was prompt as responding to any inquires we had. They put the client/traveller first and work with you to create the most memorable trip. :)',
    stars: 5,
    from: 'Booking.com',
  },
  {
    id: 3,
    imageSrc: halong3,
    name: 'Severus Snape',
    comment:
      'This tour company was amazing! Nam was absolutely fantastic to work with, he arranged everything was open to any changes we wanted to make itinerary before coming. Once in Vietnam he was prompt as responding to any inquires we had. They put the client/traveller first and work with you to create the most memorable trip. :)',
    stars: 5,
    from: 'Tripadvisor',
  },
];

export const asianCountries = [
  {
    country: 'Thailand',
    flag_image: thaiFlag,
    term_of_residence: '< 30 days',
  },
  {
    country: 'Malaysia',
    flag_image: malaysiaFlag,
    term_of_residence: '< 30 days',
  },
  {
    country: 'Singapore',
    flag_image: singaporeFlag,
    term_of_residence: '< 30 days',
  },
  {
    country: 'Indonesia',
    flag_image: indoFlag,
    term_of_residence: '< 30 days',
  },
  {
    country: 'Cambodia',
    flag_image: camFlag,
    term_of_residence: '< 30 days',
  },
  {
    country: 'Laos',
    flag_image: laoFlag,
    term_of_residence: '< 30 days',
  },
  {
    country: 'Philippines',
    flag_image: phFlag,
    term_of_residence: '< 21 days',
  },
  {
    country: 'Myanmar',
    flag_image: myFlag,
    term_of_residence: '< 14 days',
  },
  {
    country: 'Brunei',
    flag_image: BruneiFlag,
    term_of_residence: '< 14 days',
  },
  {
    country: 'South Korea',
    flag_image: skFlag,
    term_of_residence: '< 15 days',
  },
  {
    country: 'Japan',
    flag_image: jpFlag,
    term_of_residence: '< 15 days',
  },
];
export const europeanCountries = [
  {
    country: 'Russia',
    flag_image: russiaFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'Sweden',
    flag_image: swedenFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'Denmark',
    flag_image: danmarkFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'Finland',
    flag_image: finlandFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'Norway',
    flag_image: norwayFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'UK',
    flag_image: ukFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'France',
    flag_image: franceFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'Germany',
    flag_image: germanyFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'Spain',
    flag_image: spainFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'Italy',
    flag_image: italyFl,
    term_of_residence: '< 15 days',
  },
  {
    country: 'Belarus',
    flag_image: belarusFl,
    term_of_residence: '< 15 days',
  },
];

export const dynasties = [
  {
    id: 1,
    name: 'Dynastic Rules (2nd to 15th centuries)',
    description: [
      'Throughout its history, many dynasties ruled over Vietnam in between periods of Chinese occupation. There are four main dynasties to note: the Ly, the Tran, the Le, and the Nguyen. First, the Ly Dynasty drove out the Chinese, ending a thousand year-long rule, and set up a centralized the government in Hanoi.',
      ,
      'Then came the Tran Dynasty, which repelled a Mongol attack in the Red River Delta under the command of general Tran Hung Dao. These two dynasties helped build the foundation of Vietnam, as people with long-standing love for their land.',
    ],
    img: historyImg1,
    places: [
      {
        name: 'Thang Long Citadel (Hanoi)',
        description:
          'To unearth more about the dynastic history of Vietnam, explore the ruins of this royal enclosure, originally built during the Ly Dynasty.  ',
      },
      {
        name: 'Temple of Literature (Hanoi)',
        description:
          'Take a stroll through the city’s first university, established in 1070. This serene and historic structure is located just west of the Old Quarter.  ',
      },
      {
        name: 'One Pillar Pagoda (Hanoi)',
        description:
          'This sacred monument was erected by an emperor in gratitude for the birth of his son.  ',
      },
    ],
  },
  {
    id: 2,
    name: 'The Le Dynasty Pushes South (15th to 17th centuries)',
    description: [
      'China invaded Vietnam again at the turn of the 15th century, but this period did not last nearly as long as the previous occupation. Le Loi, a wealthy landowner, managed to lead a resistance and reclaim Vietnam.',
      ,
      'This established the Le Dynasty, which succeeded in expanding southward, gaining control over the former Champa Kingdom. The Cham were an ethnic group from the Indian sub-continent, that lived in central and southern Vietnam from the 2nd century. A strong kingdom with mercantile skills, they were eventually defeated and driven into the depths of the Mekong Delta.',
    ],
    img: historyImg2,
    places: [
      {
        name: 'Cham towers and complexes (Central Vietnam)',
        description:
          'Discover the vast and fascinating ruins of My Son sanctuary a few kilometres outside of Hoi An. Visit the Po Nagar towers in central Nha Trang or the Po Shanu towers a short drive from Mui Ne town.  ',
      },
      {
        name: 'Museum of Cham Sculpture (Da Nang) ',
        description:
          ' Founded during the French colonial rule, this charming building hosts incredible displays of Cham relics and sculptures.',
      },
    ],
  },
  {
    id: 3,
    name: 'The Last Dynasty (19th Century)',
    description: [
      'The Nguyens came into power during a divisive civil conflict that had left Vietnam fractured. Under the leadership of Emperor Gia Long, the country was reunited and in 1802, Gia Long constructed a new feudal capital in the city of Hue in Central Vietnam.',
      ,
      'During the reign of the Nguyen Emperors, French influence in Vietnam grew under the pretext of religious reform and evangelicalism. Eventually, the French established control over the whole of Vietnam, adding the central and northern regions to the rest of their conquests (neighbouring Laos and Cambodia). The last Nguyen emperor, Bao Dai, formally abdicated his throne.',
    ],
    img: historyImg3,
    places: [
      {
        name: 'Imperial City (Hue)',
        description:
          'Explore the legacy of the Nguyen Dynasty with a walk around the Hue Citadel and Imperial City, one of Vietnam’s top historical attractions.  ',
      },
      {
        name: 'Royal Tombs (Hue) ',
        description:
          'Make time to visit the grandiose tombs of the Nguyen Emperors, each one different from the others, and designed by the Nguyen emperors before their deaths. ',
      },
    ],
  },
  {
    id: 4,
    name: 'French Colonisation (late 19th to early 20th century)',
    description: [
      'During the French colonisation of Vietnam, the country was divided into three protectorates: Tonkin, Annam and Cochinchine. Throughout French rule, resistance brewed among the Vietnamese. ',
      ,
      'At the turn of the century many notable Vietnamese writers published works calling for solidarity and freedom from colonial rule. These ideas were temporarily silenced but not forgotten. Despite mass arrests by the French, many Vietnamese nationalists used imprisonment to spread their cause and mobilize for the future.',
    ],
    img: historyImg4,
    places: [
      {
        name: 'Con Dao Prison Complex (Con Dao Island)',
        description:
          ' While enjoying the beaches of Con Dao Island, visit the prison complex to unearth stories about its tragic past. ',
      },
      {
        name: 'Hoa Lo Prison (Hanoi)',
        description:
          ' This urban prison, a short walk from Hoan Kiem lake, was dubbed the ‘fiery furnace’ by locals. ',
      },
      {
        name: 'French Quarter (Hanoi) ',
        description:
          'Take a stroll around Hoan Kiem District to encounter many well-preserved French villas, as well as other architectural relics from the French colonisation, including Long Bien Bridge and the Metropole Hotel.',
      },
    ],
  },
  {
    id: 5,
    name: 'Invasion to Independence (early to mid-20th century)',
    description: [
      'When France was occupied by Germany, Japan seized the opportunity to invade Vietnam. This strategic move resulted in Japanese forces taking control of Hanoi in 1940. ',
      ,
      'A year later they moved further south, along the way awakening remaining elements of the Vietnamese resistance and spurring communists and nationalists to band together to form the Viet Minh under Ho Chi Minh. The Viet Minh destabilized the Japanese, and by 1945, Japan surrendered to Allied forces on the same day Ho Chi Minh declared Vietnam an independent nation in Hanoi’s Ba Dinh Square.',
    ],
    img: historyImg5,
    places: [
      {
        name: 'Cannon Fort (Cat Ba) ',
        description:
          'This hilltop fort was built by the Japanese after their invasion of Cat Ba. Discover more about this event and enjoy the views of the port and jungle below. ',
      },
      {
        name: 'Ba Dinh Square (Hanoi) ',
        description:
          'Visit this iconic square in front of the Ho Chi Minh Mausoleum, before checking out the Presidential Palace and Ho Chi Minh’s stilt house.',
      },
    ],
  },

  {
    id: 6,
    name: 'The Indochina Wars & Reunification (mid-20th century)',
    description: [
      'Resistance to French colonial rule came to a head when the First Indochina War began in 1946. The war lasted until a stark defeat at the Battle of Dien Bien Phu. After a ceasefire was signed, Vietnam was divided at the 17th parallel, setting the stage for a war that would capture worldwide attention.',
      ,
      'American involvement in South Vietnam had begun well beforehand, and as the United States committed more and more forces to the war effort, so did North Vietnam. The Tet Offensive marked a turning point for north, and ultimately American forces retreated from Saigon as the city was taken by North Vietnamese troops on April 30, 1975.',
    ],
    img: historyImg6,
    places: [
      {
        name: 'War Remnants Museum (Ho Chi Minh City) ',
        description:
          'This museum showcases the harsh reality of the war through the lenses of renowned  photographers on both sides of the conflict.',
      },
      {
        name: 'Reunification Palace (Ho Chi Minh City)',
        description:
          'Take a stroll around this former seat of power for the Republic of Vietnam. The day the Viet Cong tanks crashed through the gates of the palace marked the end of the war.',
      },
      {
        name: 'Cu Chi Tunnels',
        description:
          'These underground tunnels outside Ho Chi Minh City reveal how the Viet Cong guerrilla forces survived and waged war under remarkable conditions.',
      },
    ],
  },

  {
    id: 7,
    name: 'Doi Moi & Vietnam Now (late 20th century to the present)',
    description: [
      'After the Second Indochina War, the country went through a period of adjustment and reunification. In 1986, the Vietnamese government introduced its ‘Doi Moi’ (renewal) policy nationwide. These reforms resulted in gradual economic growth, as more and more Vietnamese began to open businesses.',
      ,
      'Recently, Vietnam has seen a boom in development, and is one of the region’s fastest-growing economies. The country offers is a fascinating mix of old and new, with compelling historical attractions and a deeply rooted sense of appreciation for its past.',
    ],
    img: historyImg7,
    places: [],
  },
];

export const services = [
  {
    id: 1,
    service: 'hotel',
    description:
      'We have connections with all the best hotels all over Vietnam. We will do our best to make your stay as enjoyable as possible.',
    icon: hotelIcon,
    border: 'border-b md:border-r',
  },
  {
    id: 2,
    service: 'ticket',
    description:
      'It is our pleasure to assist you with booking plain, train, bus tickets or any other travel services everywhere in Vietnam.',
    icon: ticketIcon,
    border: 'border-b lg:border-r',
  },
  {
    id: 3,
    service: 'rentals',
    description:
      'We also offer car, motorbike rental with affordable prices & sim-cards with fast internet access with good connection in every region in Vietnam.',
    icon: rentalsIcon,
    border: 'border-b md:border-r  lg:border-r-0',
  },
  {
    id: 4,
    service: 'tours',
    description:
      "We specialize in group tours, private tours and adventure tours for all regions in Vietnam. Especially, we can customize our tours to meet your family's needs.",
    icon: toursIcon,
    border: 'border-b lg:border-r lg:border-b-0',
  },
  {
    id: 5,
    service: 'guide',
    description:
      'Our guides are friendly, and knowledgeable. We take extra care in choosing the right guide for your trips to suit your language, travel and food preferences.',
    icon: guideIcon,
    border: 'border-b md:border-r md:border-b-0  lg:border-b-0',
  },
  {
    id: 6,
    service: 'visa',
    description:
      'We offer a wide range of visa services including: visa extension, renewal, work permit, residence card...',
    icon: visaIcon,
    border: '',
  },
];

// export const newTours = [
//   {
//     id: 1,
//     name: 'Mui Ne Jeep Tour',
//     price: '$40',
//     imageSrc: muineImg,
//     imageAlt: 'A man standing on sand dune',
//     images: [cuchiImg, mekongImg, cangioImg, hueImg, hanoiImg],
//     region: 'Muine',
//     duration: '1 Day',
//     startDate: 'Everyday',
//     description: `The endless white sand beaches; the charming fishing villages, the desert-like dunes and numerous types of rare flora and fauna make Mui Ne an ideal place for anyone seeking an enjoyable escape.`,
//     itinerary: [
//       {
//         hightLight: `Fairy Stream - Fishing Village - White Sand Dune - Yellow Sand Dune`,
//         details: [
//           '4:30AM: Driver will pick you up at your hotel/ resort by private jeep.',
//           `5:15AM: Visiting White sand dunes. At the top of the sand dune, catching the first sunrise of the day. Other activities can be taken: riding quad bike over sand dunes and ostrich riding (at own expense), sliding down sand dunes’ slopes with sand boarding`,
//           `6:00AM: Continue with your jeep to visit Red sand dunes, slopes are less steep than the White sand dunes, but great opportunity for taking photo as red color of the sand is great contrast to background scenery.`,
//           `7:15AM: Visiting the fishing village, observing the daily lives of fishermen, morning catch is hauled to shore and women are busy sorting out the catch and fishing boats are lining up and waiting to depart.`,
//           `7:45AM: Visiting Fairy stream where the small stream running through the middle of the red sand dunes. It is like a mini version of Red Canyon`,
//           `8:30AM Returning back to your hotel/resort. Tour end.`,
//         ],
//       },
//     ],
//     included: [
//       'Modern air-con transport, pick-up and drop-off at hotel.',
//       'Meals as mentioned in the itineraries.',
//       'All entrance fees',
//       `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
//       'Mineral Water (2 bottles/person)',
//       'Insurance',
//     ],
//     excluded: [
//       'Beverages and other meals are not mentioned in the program.',
//       'Visa fees to Vietnam',
//       `Personal Expenses (laundry, telephone, shopping…)`,
//       'Tip/Gratuity',
//       `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
//     ],
//     cancellationPolicy: [
//       `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
//       `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
//       `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
//     ],
//     confirmationPolicy: [
//       `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
//       `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
//       `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
//     ],
//     additionalInfo: [
//       `Infants must sit on laps`,
//       `Children must be accompanied by an adult`,
//       `Please advise any specific dietary requirements at time of booking`,
//       `Not wheelchair accessible`,
//       `Not recommended for pregnant travelers`,
//       `Children under 18 cannot book this tour alone`,
//       `This tour/activity will have a maximum of 50 travelers`,
//       `Operated by Reverie Travel`,
//     ],
//   },
//   {
//     id: 2,
//     name: 'Monkey Island',
//     price: '$50',
//     imageSrc: cangioImg,
//     imageAlt: 'Can Gio island',
//     images: [cuchiImg, mekongImg, cangioImg, hueImg, hanoiImg],
//     region: 'CanGio',
//     duration: '1 day',
//     startDate: 'Everyday',
//     description:
//       'Experience the peace and tranquility of life along the Mekong Delta during this day cruise from Ho Chi Minh City. Escape the hustle of urban streets and relax into the scenic countryside as you tour the watery landscape of southern Vietnam.',
//     itinerary: [
//       {
//         hightLight: `Mangrove forest - Monkey Island - Monkey island`,
//         details: [
//           `8.15am : Depart to Can Gio. At Can Gio Island`,
//           `Visiting heaps of the long-tailed monkeys`,
//           `Visiting The crocodile farm and other wild animals in mangrove forest`,
//           `Speed jungle boat, the climax of tour, take you to the Vietnamese base in the war`,
//           `Having Vietnamese style lunch.Free time at swimming pool.`,
//           `Relax or walk around for sight-seeing. Drop in public seashore (The 30th April Beach) where lots of street snacks and seafood are available.`,
//         ],
//       },
//     ],
//     included: [
//       'Modern air-con transport, pick-up and drop-off at hotel.',
//       'Meals as mentioned in the itineraries.',
//       'All entrance fees',
//       `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
//       'Mineral Water (2 bottles/person)',
//       'Insurance',
//     ],
//     excluded: [
//       'Beverages and other meals are not mentioned in the program.',
//       'Visa fees to Vietnam',
//       `Personal Expenses (laundry, telephone, shopping…)`,
//       'Tip/Gratuity',
//       `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
//     ],
//     cancellationPolicy: [
//       `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
//       `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
//       `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
//     ],
//     confirmationPolicy: [
//       `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
//       `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
//       `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
//     ],
//     additionalInfo: [
//       `Infants must sit on laps`,
//       `Children must be accompanied by an adult`,
//       `Please advise any specific dietary requirements at time of booking`,
//       `Not wheelchair accessible`,
//       `Not recommended for pregnant travelers`,
//       `Children under 18 cannot book this tour alone`,
//       `This tour/activity will have a maximum of 50 travelers`,
//       `Operated by Reverie Travel`,
//     ],
//   },
//   {
//     id: 3,
//     name: 'Saigon on a bike',
//     price: '$89',
//     imageSrc: vespaImg,
//     imageAlt: 'People sitting on Vespa',
//     images: [cuchiImg, mekongImg, cangioImg, hueImg, hanoiImg],
//     region: 'HCM City',
//     duration: '1 day',
//     startDate: 'Everyday',
//     description: `Discover local eateries that serve authentic Vietnamese favorites on a half-day street food tour of Ho Chi Minh City. Travel by motorbike with your guide to various locations to sample a range of food and drink, getting an intimate experience of Vietnam's vibrant street life along the way.`,
//     itinerary: [
//       {
//         hightLight: `Vibrant streets of Ho Chi Minh City - Food tour by motorbike`,
//         details: [
//           `Discover local eateries that serve authentic Vietnamese favorites on a half-day street food tour of Ho Chi Minh City. `,
//           `Half-day food tour by motorbike in Ho Chi Minh City`,
//           `Travel by motorbike with your guide to various locations to sample a range of food and drink, getting an intimate experience of Vietnam's vibrant street life along the way.`,
//           `Try different Vietnamese dishes at local eateries`,
//           `Experience the vibrant streets of Ho Chi Minh City`,
//           `Includes food, guide, and hotel pickup and drop-off`,
//         ],
//       },
//     ],
//     included: [
//       'Modern air-con transport, pick-up and drop-off at hotel.',
//       'Meals as mentioned in the itineraries.',
//       'All entrance fees',
//       `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
//       'Mineral Water (2 bottles/person)',
//       'Insurance',
//     ],
//     excluded: [
//       'Beverages and other meals are not mentioned in the program.',
//       'Visa fees to Vietnam',
//       `Personal Expenses (laundry, telephone, shopping…)`,
//       'Tip/Gratuity',
//       `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
//     ],
//     cancellationPolicy: [
//       `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
//       `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
//       `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
//     ],
//     confirmationPolicy: [
//       `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
//       `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
//       `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
//     ],
//     additionalInfo: [
//       `Infants must sit on laps`,
//       `Children must be accompanied by an adult`,
//       `Please advise any specific dietary requirements at time of booking`,
//       `Not wheelchair accessible`,
//       `Not recommended for pregnant travelers`,
//       `Children under 18 cannot book this tour alone`,
//       `This tour/activity will have a maximum of 50 travelers`,
//       `Operated by Reverie Travel`,
//     ],
//   },
//   {
//     id: 4,
//     name: 'Hue - Phong Nha 2 Days',
//     price: '$35',
//     imageSrc: phongnhaImg,
//     imageAlt: 'Hue',
//     images: [cuchiImg, mekongImg, cangioImg, hueImg, hanoiImg],
//     region: 'Hue',
//     duration: '2D1N',
//     startDate: 'Everyday',
//     description: `On this Phong Nha Caves tour from Hue, you’ll explore the UNESCO-listed complex of 14 grottoes in the limestone mountains of Ke Bang National Park. Used by the Cham people in the ninth and 10th centuries as Buddhist sanctuaries, the caves still contain the remains of altars and inscriptions.`,
//     itinerary: [
//       {
//         hightLight: `HUE – PHONG NHA CAVE – DONG HOI`,
//         details: [
//           `06:30. Tour guide of our company will pick up at your hotel. Move to the National park of Phong Nha – Ke Bang – classified as the world heritage site, stop over at La Vang Church and pass over some famous places DMZ : Hien Luong Bridge, Ben Hai river, Doc Mieu Based. `,
//           `11:45. Have lunch at restaurant`,
//           `13:00. Boat trip on Son river to discover Phong Nha Cave, visit the caves named Cung Dinh grotto, Tien grotto.`,
//           `15:30. Back to Dong Hoi city, check in hotel and free to explore Dong Hoi by night.`,
//         ],
//       },
//       {
//         highLight: `DONG HOI – PARADISE CAVE – HUE `,
//         details: [
//           `In the morning: Enjoy the breakfast with local food at hotel.`,
//           `10:30. Pick you up at your hotel in Dong Hoi transfer to Phong Nha.`,
//           `11:45. Have lunch at restaurant. The golf cars will take you to Paradise cave in the ecological tourist zone of Paradise cave. Is like “ the Eden on the earth”. The special stalagmites, stalactites system with sparkling, mysterious beauty, out of human beings imagination. Tis spectacular and magical beauty are welcome visitors to come and enjoy.`,
//           `15:30. Back to Hue on Ho Chi Minh road ( Historical road in Vietnamese war)`,
//           `19:30. We arrive in Hue and drop you off at your hotel.`,
//         ],
//       },
//     ],
//     included: [
//       'Modern air-con transport, pick-up and drop-off at hotel.',
//       'Meals as mentioned in the itineraries.',
//       'All entrance fees',
//       `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
//       'Mineral Water (2 bottles/person)',
//       'Insurance',
//     ],
//     excluded: [
//       'Beverages and other meals are not mentioned in the program.',
//       'Visa fees to Vietnam',
//       `Personal Expenses (laundry, telephone, shopping…)`,
//       'Tip/Gratuity',
//       `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
//     ],
//     cancellationPolicy: [
//       `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
//       `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
//       `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
//     ],
//     confirmationPolicy: [
//       `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
//       `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
//       `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
//     ],
//     additionalInfo: [
//       `Infants must sit on laps`,
//       `Children must be accompanied by an adult`,
//       `Please advise any specific dietary requirements at time of booking`,
//       `Not wheelchair accessible`,
//       `Not recommended for pregnant travelers`,
//       `Children under 18 cannot book this tour alone`,
//       `This tour/activity will have a maximum of 50 travelers`,
//       `Operated by Reverie Travel`,
//     ],
//   },
//   {
//     id: 5,
//     name: 'My Son Holy Land',
//     price: '$89',
//     imageSrc: mysonImg,
//     imageAlt: 'MySon sanctuary',
//     images: [cuchiImg, mekongImg, cangioImg, hueImg, hanoiImg],
//     region: 'MySon',
//     duration: '1 Day',
//     startDate: 'Everyday',
//     description: `This tour is a great offer to help guests BEAT THE CROWDS, AVOID THE HEAT and the risks of covid 19 from large groups. A professional English speaking guide who grew up near the sanctuary as a local will deliver most interesting stories and cultural values of the site.`,
//     itinerary: [
//       {
//         highLight: `HOI AN - MY SON HOLYLAND – TRADITIONAL VILLAGE`,
//         details: [
//           `This tour is a great offer to help guests BEAT THE CROWDS, AVOID THE HEAT and the risks of covid 19 from large groups. A professional English speaking guide who grew up near the sanctuary as a local will deliver most interesting stories and cultural values of the site.`,
//           `Early morning is the best time to capture the most stunning photos at the sanctuary.`,
//           `Guests will not only learn about Champa culture and local lives, traditional and cultural practice, the Vietnam war, etc... This can not be achieved by any other suppliers.`,
//           `After visiting, taking the best photos and listening to historic stories of the ancient temples from the unique guide, visitors will take a rest in a local home restaurant and have breakfast and coffee (included).`,
//           `Then travelers will be dropped back to the hotels and save much time for other activities.`,
//         ],
//       },
//     ],
//     included: [
//       'Modern air-con transport, pick-up and drop-off at hotel.',
//       'Meals as mentioned in the itineraries.',
//       'All entrance fees',
//       `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
//       'Mineral Water (2 bottles/person)',
//       'Insurance',
//     ],
//     excluded: [
//       'Beverages and other meals are not mentioned in the program.',
//       'Visa fees to Vietnam',
//       `Personal Expenses (laundry, telephone, shopping…)`,
//       'Tip/Gratuity',
//       `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
//     ],
//     cancellationPolicy: [
//       `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
//       `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
//       `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
//     ],
//     confirmationPolicy: [
//       `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
//       `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
//       `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
//     ],
//     additionalInfo: [
//       `Infants must sit on laps`,
//       `Children must be accompanied by an adult`,
//       `Please advise any specific dietary requirements at time of booking`,
//       `Not wheelchair accessible`,
//       `Not recommended for pregnant travelers`,
//       `Children under 18 cannot book this tour alone`,
//       `This tour/activity will have a maximum of 50 travelers`,
//       `Operated by Reverie Travel`,
//     ],
//   },
//   {
//     id: 6,
//     name: 'Bai Dinh - Trang An',
//     price: '$35',
//     imageSrc: tranganImg,
//     imageAlt: 'People walking along rice field in Sapa',
//     images: [cuchiImg, mekongImg, cangioImg, hueImg, hanoiImg],
//     region: 'TrangAn',
//     duration: '1 Day',
//     startDate: 'Everyday',
//     description: `With hundreds of big and small statutes, numerous categories of architectural works, Bai Dinh – Trang An combined complex is one of the biggest in Vietnam and has become a must–see place for almost travelers these days.`,
//     itinerary: [
//       {
//         highLight: `HANOI - BAI DINH PAGODA - TRANG AN ECO TOURISM`,
//         details: [
//           `07:40 – 8:30 Get picked up by our tour guide and bus at your addresses around Hanoi Center then depart for Bai Dinh pagoda and Trang an eco-tourism attraction area (120kms south of Hanoi).`,
//           `10:30 Arrive in Buddha Sanctuary place of Bai Dinh Pagoda, the biggest one in Vietnam with 500 Arhan statues. You can see a biggest bronze Buddha statue in Vietnam with 10 meters in height, 100 tons in weight. Tour guide also gives you an introduction of beliefs and religions in Vietnam.`,
//           `12:30 Have lunch in a local restaurant with some special dishes such as goat meat, pork storage vessel…`,
//           `13:30 Leave for Trang An eco-tourism attraction. You will be amazed by neglected area while having boat trip through cave chains: Sang Cave, Toi Cave, Ba Giot Cave, Sinh Cave…experiencing mysterious views of  the so-called “Ha Long Bay in land”`,
//           `16:00 Get back to the bus and then return to Hanoi.`,
//           `18:30 Back in Hanoi, you get dropped off at your address. Tour ends.`,
//         ],
//       },
//     ],
//     included: [
//       'Modern air-con transport, pick-up and drop-off at hotel.',
//       'Meals as mentioned in the itineraries.',
//       'All entrance fees',
//       `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
//       'Mineral Water (2 bottles/person)',
//       'Insurance',
//     ],
//     excluded: [
//       'Beverages and other meals are not mentioned in the program.',
//       'Visa fees to Vietnam',
//       `Personal Expenses (laundry, telephone, shopping…)`,
//       'Tip/Gratuity',
//       `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
//     ],
//     cancellationPolicy: [
//       `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
//       `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
//       `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
//     ],
//     confirmationPolicy: [
//       `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
//       `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
//       `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
//     ],
//     additionalInfo: [
//       `Infants must sit on laps`,
//       `Children must be accompanied by an adult`,
//       `Please advise any specific dietary requirements at time of booking`,
//       `Not wheelchair accessible`,
//       `Not recommended for pregnant travelers`,
//       `Children under 18 cannot book this tour alone`,
//       `This tour/activity will have a maximum of 50 travelers`,
//       `Operated by Reverie Travel`,
//     ],
//   },
//   {
//     id: 7,
//     name: 'Hoa Lu - Cuc Phuong',
//     price: '$35',
//     imageSrc: perfumeImg,
//     imageAlt: 'People walking along rice field in Sapa',
//     images: [cuchiImg, mekongImg, cangioImg, hueImg, hanoiImg],
//     region: 'Hanoi',
//     duration: '1 Day',
//     startDate: 'Everyday',
//     description: `Cuc Phuong is now the biggest and the most diverse Park in Vietnam with a variety of rare fauna and flora in limestone mountain forest. The Endangered Primates Rescued Centre (EPRC) in the park is an interesting place to see many kinds of rare primates such as Langur, Gibbon and Loris all over Vietnam. Many of them are under threat of extinction.`,
//     itinerary: [
//       {
//         highLight: `Hanoi - Hoa Lu - Tam Coc`,
//         details: [
//           `07:30 - 8:30 Tour guide pick you up at your hotel then depart for ancient citadel of Hoa Lu (90 km south of Hanoi).`,
//           `11:00 Visit temples dedicated to King Dinh Tien Hoang (923-979) and Le Dai Hanh (941-1005). Tour guide give you an introduction of Vietnam history in 10th century.`,
//           `12:00 Continue bus drive to Tam Coc for lunch. On the way take pictures of villages and the stunning landscapes.`,
//           `13:30 Board on sampans to visit Tam Coc (Three caves). The boat trip through enormous limestone karsts jutting out from the green rice fields leave a good memory.`,
//           `15:30 Finishing 2 hours on sampan, check in hotel. Relax in hotel after long day of activity.`,
//           `17:00 Dinner at your hotel and stay overnight in Tam Coc.`,
//         ],
//       },
//       {
//         highLight: `Tam Coc - Cuc Phuong - Hanoi `,
//         details: [
//           `07:00 Enjoy morning tea/coffee then have breakfast at your hotel restaurant.`,
//           `07:40 Depart for Cuc Phuong National Park, photographing spectacular views through countryside road.`,
//           `09:20 Visit Endangered Primate Rescue Center which homes to species like Golden-headed Langur, Tonkin Snub-nosed Langur and Black Crested Gibbon…`,
//           `10:30 Experience thrilling moments when exploring Cave of Pre-historic Man dated back 7000 years old.`,
//           `11:30 Enjoy a local style Vietnamese lunch at the National Park Headquarters.`,
//         ],
//       },
//     ],
//     included: [
//       'Modern air-con transport, pick-up and drop-off at hotel.',
//       'Meals as mentioned in the itineraries.',
//       'All entrance fees',
//       `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
//       'Mineral Water (2 bottles/person)',
//       'Insurance',
//     ],
//     excluded: [
//       'Beverages and other meals are not mentioned in the program.',
//       'Visa fees to Vietnam',
//       `Personal Expenses (laundry, telephone, shopping…)`,
//       'Tip/Gratuity',
//       `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
//     ],
//     cancellationPolicy: [
//       `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
//       `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
//       `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
//     ],
//     confirmationPolicy: [
//       `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
//       `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
//       `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
//     ],
//     additionalInfo: [
//       `Infants must sit on laps`,
//       `Children must be accompanied by an adult`,
//       `Please advise any specific dietary requirements at time of booking`,
//       `Not wheelchair accessible`,
//       `Not recommended for pregnant travelers`,
//       `Children under 18 cannot book this tour alone`,
//       `This tour/activity will have a maximum of 50 travelers`,
//       `Operated by Reverie Travel`,
//     ],
//   },
//   {
//     id: 8,
//     name: 'Hanoi - Bat Trang',
//     price: '$35',
//     imageSrc: perfumeImg,
//     imageAlt: 'People walking along rice field in Sapa',
//     images: [cuchiImg, mekongImg, cangioImg, hueImg, hanoiImg],
//     region: 'Hanoi',
//     duration: '1 Day',
//     startDate: 'Everyday',
//     description: `Bat Trang was known as a famous ceramic producing village formed in 14th century. The village is located near by the Red River which is close to Hanoi city. Bat Trang became the center of ceramic making because of the rich deposition of white clay.`,
//     itinerary: [
//       {
//         highLight: `HA NOI CITY - BAT TRANG CERAMICS VILLAGE TOUR`,
//         details: [
//           `07:45 - 8:30 Get picked up by our tour guide and bus then visit first place named Tran Quoc pagoda. Experience our national heritage and the beautiful Buddhist relics on the West Lake.`,
//           `09:30 Visit a sacred place to recall President Ho Chi Minh’s life and career in Ho Chi Minh’s Mausoleum, the Stilt-house where Ho Chi Minh lived and worked from 1958 to 1969.`,
//           `10:30 Visit One Pillar Pagoda, the one modeled after a lotus flower, a symbol of Hanoi city in present days.`,
//           `11:00 Visit the Temple of Literature, considering the first university of Viet Nam. The temple was first constructed in 1070 under King Ly Nhan Tong and dedicated to Confucius, sages and scholars.`,
//           `12:30 Have Vietnamese lunch at a local restaurant in Hanoi Old Quarter and relax.`,
//           `13:30 Continue exploring the daily life of traditional ceramics village of Bat Trang. Visit the pottery showrooms and see how they modeled the products.`,
//           `14:30 Drive back to Hoan Kiem lake to visit Ngoc Son Temple dedicated to Van Xuong Saint and Tran Hung Dao General Commander for his struggle against Mongolians.`,
//           `15:30 Arrive back your hotel. Tour ends.`,
//           `CYCLO RIDE (optional): Pay extra 100,000 VND per person.`,
//           `Riding on a cyclo for one hour around the Old Quarter will bring you a wonderful memory in Hanoi.`,
//         ],
//       },
//     ],
//     included: [
//       'Modern air-con transport, pick-up and drop-off at hotel.',
//       'Meals as mentioned in the itineraries.',
//       'All entrance fees',
//       `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
//       'Mineral Water (2 bottles/person)',
//       'Insurance',
//     ],
//     excluded: [
//       'Beverages and other meals are not mentioned in the program.',
//       'Visa fees to Vietnam',
//       `Personal Expenses (laundry, telephone, shopping…)`,
//       'Tip/Gratuity',
//       `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
//     ],
//     cancellationPolicy: [
//       `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
//       `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
//       `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
//     ],
//     confirmationPolicy: [
//       `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
//       `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
//       `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
//     ],
//     additionalInfo: [
//       `Infants must sit on laps`,
//       `Children must be accompanied by an adult`,
//       `Please advise any specific dietary requirements at time of booking`,
//       `Not wheelchair accessible`,
//       `Not recommended for pregnant travelers`,
//       `Children under 18 cannot book this tour alone`,
//       `This tour/activity will have a maximum of 50 travelers`,
//       `Operated by Reverie Travel`,
//     ],
//   },
// ];

// export const placesFirst = [
//   { id: 1, imageSrc: placesSG, name: 'Saigon' },
//   { id: 2, imageSrc: placesPQ, name: 'PhuQuoc' },
//   { id: 3, imageSrc: placesDN, name: 'Danang' },
// ];

// export const placesSecond = [
//   { id: 1, imageSrc: placesHN, name: 'Hanoi' },
//   { id: 2, imageSrc: sapa1, name: 'Sapa' },
//   { id: 3, imageSrc: placesHoianImg, name: 'Hoian' },
// ];

// export const galleryPlaces = [
//   { id: 1, imageSrc: placesHN, name: 'Hanoi' },
//   { id: 2, imageSrc: placesDN, name: 'Danang' },
//   { id: 3, imageSrc: placesPQ, name: 'PhuQuoc' },
//   { id: 4, imageSrc: placesSG, name: 'Saigon' },
//   { id: 5, imageSrc: sapa2, name: 'Sapa' },
//   { id: 6, imageSrc: sapa3, name: 'Sapa' },
//   { id: 7, imageSrc: sapa4, name: 'Sapa' },
//   { id: 8, imageSrc: sapa5, name: 'Sapa' },
// ];

// export const singleTour = {
//   id: 1,
//   name: 'Cu Chi Tunnel',
//   price: '$48',
//   imageSrc: cuchiImg,
//   imageAlt: 'People having fun in Cu Chi tunnels',
//   images: [cuchiImg, mekongImg, cangioImg, hueImg, hanoiImg],
//   region: 'HCM City',
//   duration: '1 day',
//   startDate: 'Everyday',
//   description: `Visit one of southern Vietnam’s top destinations on this 6-hour tour from Ho Chi Minh City to the Cu Chi Tunnels. Learn from your guide about the war and how the north Vietnamese army used the vast network of tunnels.`,
//   itinerary: [
//     {
//       highLight: `HCM City - Cu chi - HCM City`,
//       details: [
//         'Escape the bustle of the city to explore the rural scenery and the famous Cu Chi Tunnels in Southern Vietnam. Step in the shoes of a Viet Cong fighter, as you climb through an impressive 155-mile (250-km) long tunnel network, and visit a typical gun shooting area.',
//         `Enjoy a convenient hotel pickup at from your guide as you depart for Cu Chi. Along the way, watch as the frantic city scenery transitions to a more peaceful, rural setting. Witness passing rice paddy farms, quaint roadside vendors, and increasingly lush greenery.`,
//         `Once you arrive, begin with a tour the Cu Chi Tunnels, some of the most famous underground networks of pathways, hideouts, sleeping quarters, meeting rooms, hospitals, and Hoang Cam Stove. These narrow tunnels provide barely enough space for a single person to crawl their way through, though some are now wider to accommodate visitors. Also learn that the mere 10–13 feet (3–4 m) thick level of upper soil can support the bearing weight of a 55 ton (50 mT) tank and the explosive damage of bombs.`,
//         `Following, watch an insightful film about the wartime experience before further exploring the tunnel's trap doors and underground quarters. Then make a visit to huge bomb craters left from the war, the Garment-factory Ammunition and Souvenir Shops, and the Museum of Self-made Weapons. Get the exhilarating opportunity to fire a M-15, AK-47, and a carbine rifle at the National Defense Sports Shooting Range for a true wartime experience. Finally, savor the Vietnamese traditional soup, Pho, and a local tapioca recipe before the comfortable ride back to your Ho Chi Minh hotel at around 2:30 PM (for morning session) or around 6:30 PM (for afternoon session).`,
//       ],
//     },
//     {
//       highLight: `HCM City - Cu chi - HCM City`,
//       details: [
//         'Escape the bustle of the city to explore the rural scenery and the famous Cu Chi Tunnels in Southern Vietnam. Step in the shoes of a Viet Cong fighter, as you climb through an impressive 155-mile (250-km) long tunnel network, and visit a typical gun shooting area.',
//         `Enjoy a convenient hotel pickup at from your guide as you depart for Cu Chi. Along the way, watch as the frantic city scenery transitions to a more peaceful, rural setting. Witness passing rice paddy farms, quaint roadside vendors, and increasingly lush greenery.`,
//         `Once you arrive, begin with a tour the Cu Chi Tunnels, some of the most famous underground networks of pathways, hideouts, sleeping quarters, meeting rooms, hospitals, and Hoang Cam Stove. These narrow tunnels provide barely enough space for a single person to crawl their way through, though some are now wider to accommodate visitors. Also learn that the mere 10–13 feet (3–4 m) thick level of upper soil can support the bearing weight of a 55 ton (50 mT) tank and the explosive damage of bombs.`,
//         `Following, watch an insightful film about the wartime experience before further exploring the tunnel's trap doors and underground quarters. Then make a visit to huge bomb craters left from the war, the Garment-factory Ammunition and Souvenir Shops, and the Museum of Self-made Weapons. Get the exhilarating opportunity to fire a M-15, AK-47, and a carbine rifle at the National Defense Sports Shooting Range for a true wartime experience. Finally, savor the Vietnamese traditional soup, Pho, and a local tapioca recipe before the comfortable ride back to your Ho Chi Minh hotel at around 2:30 PM (for morning session) or around 6:30 PM (for afternoon session).`,
//       ],
//     },
//     {
//       highLight: `HCM City - Cu chi - HCM City`,
//       details: [
//         'Escape the bustle of the city to explore the rural scenery and the famous Cu Chi Tunnels in Southern Vietnam. Step in the shoes of a Viet Cong fighter, as you climb through an impressive 155-mile (250-km) long tunnel network, and visit a typical gun shooting area.',
//         `Enjoy a convenient hotel pickup at from your guide as you depart for Cu Chi. Along the way, watch as the frantic city scenery transitions to a more peaceful, rural setting. Witness passing rice paddy farms, quaint roadside vendors, and increasingly lush greenery.`,
//         `Once you arrive, begin with a tour the Cu Chi Tunnels, some of the most famous underground networks of pathways, hideouts, sleeping quarters, meeting rooms, hospitals, and Hoang Cam Stove. These narrow tunnels provide barely enough space for a single person to crawl their way through, though some are now wider to accommodate visitors. Also learn that the mere 10–13 feet (3–4 m) thick level of upper soil can support the bearing weight of a 55 ton (50 mT) tank and the explosive damage of bombs.`,
//         `Following, watch an insightful film about the wartime experience before further exploring the tunnel's trap doors and underground quarters. Then make a visit to huge bomb craters left from the war, the Garment-factory Ammunition and Souvenir Shops, and the Museum of Self-made Weapons. Get the exhilarating opportunity to fire a M-15, AK-47, and a carbine rifle at the National Defense Sports Shooting Range for a true wartime experience. Finally, savor the Vietnamese traditional soup, Pho, and a local tapioca recipe before the comfortable ride back to your Ho Chi Minh hotel at around 2:30 PM (for morning session) or around 6:30 PM (for afternoon session).`,
//       ],
//     },
//   ],
//   included: [
//     'Modern air-con transport, pick-up and drop-off at hotel.',
//     'Meals as mentioned in the itineraries.',
//     'All entrance fees',
//     `English-speaking guide (other languages available upon request depending on availability. A small surcharge may apply to some languages)`,
//     'Mineral Water (2 bottles/person)',
//     'Insurance',
//   ],
//   excluded: [
//     'Beverages and other meals are not mentioned in the program.',
//     'Visa fees to Vietnam',
//     `Personal Expenses (laundry, telephone, shopping…)`,
//     'Tip/Gratuity',
//     `Any additional expenses caused by reasons beyond our control such as natural calamities (typhoon, floods), flight delays, rescheduling or cancellations, any accidents, medical evacuations, riots, strikes etc...`,
//   ],
//   cancellationPolicy: [
//     `If client cancels at least 7 day(s) in advance of the scheduled departure, there is no cancellation fee.`,
//     `If client cancels between 3 and 6 day(s) in advance of the scheduled departure, there is a 50 percent cancellation fee.`,
//     `If client cancels within 2 day(s) of the scheduled departure, there is a 100 percent cancellation fee.`,
//   ],
//   confirmationPolicy: [
//     `The customer receives a confirmation voucher via email within 24 hours of successful booking`,
//     `In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email.`,
//     `Alternatively, the customer may choose to cancel their booking and a full refund will be processed.`,
//   ],
//   additionalInfo: [
//     `Infants must sit on laps`,
//     `Children must be accompanied by an adult`,
//     `Please advise any specific dietary requirements at time of booking`,
//     `Not wheelchair accessible`,
//     `Not recommended for pregnant travelers`,
//     `Children under 18 cannot book this tour alone`,
//     `This tour/activity will have a maximum of 50 travelers`,
//     `Operated by Reverie Travel`,
//   ],
//   averageRating: 5,
//   numReviews: 1,
//   reviews: [
//     {
//       _id: '620cfc4608c82135e823a357',
//       rating: 5,
//       title: 'Great service from Reverie travel',
//       comment: 'best tour ever!',
//       product: '620486f7facd223de7588b53',
//       createdAt: '2022-02-16T13:29:42.150Z',
//       updatedAt: '2022-02-16T13:29:42.150Z',

//       user: {
//         email: 'namnguyen@gmail.com',
//         name: 'Nam Nguyen',
//         role: 'customer',
//         _id: '620486f7facd223de7588b4d',
//       },
//     },
//   ],
// };
